var Common;
(function (Common) {
    var Config = (function () {
        function Config() {
        }
        return Config;
    })();
    Common.Config = Config;
})(Common || (Common = {}));

/// <reference path="../tools/typings/tsd.d.ts" />
var Common;
(function (Common) {
    var ConfigurableRoute = (function () {
        function ConfigurableRoute($title, $settings, $controller, $controllerAs, $name, $templateUrl, $resolve, $redirectTo, $reloadOnSearch, $caseInsensitiveMatch) {
            this.$title = $title;
            this.$settings = $settings;
            this.$controller = $controller;
            this.$controllerAs = $controllerAs;
            this.$name = $name;
            this.$templateUrl = $templateUrl;
            this.$resolve = $resolve;
            this.$redirectTo = $redirectTo;
            this.$reloadOnSearch = $reloadOnSearch;
            this.$caseInsensitiveMatch = $caseInsensitiveMatch;
            this.title = $title;
            this.settings = $settings;
            this.controller = $controller;
            this.controllerAs = $controllerAs;
            this.name = $name;
            this.templateUrl = $templateUrl;
            this.resolve = $resolve;
            this.redirectTo = $redirectTo;
            this.reloadOnSearch = $reloadOnSearch;
            this.caseInsensitiveMatch = $caseInsensitiveMatch;
        }
        return ConfigurableRoute;
    })();
    Common.ConfigurableRoute = ConfigurableRoute;
})(Common || (Common = {}));

var Common;
(function (Common) {
    var Controller = (function () {
        function Controller($scope) {
            this.scope = $scope;
            this.scope.events = this;
        }
        return Controller;
    })();
    Common.Controller = Controller;
})(Common || (Common = {}));

var Common;
(function (Common) {
    var Factory = (function () {
        function Factory() {
        }
        return Factory;
    })();
    Common.Factory = Factory;
})(Common || (Common = {}));

var Common;
(function (Common) {
    var Filter = (function () {
        function Filter() {
        }
        return Filter;
    })();
    Common.Filter = Filter;
})(Common || (Common = {}));

/// <reference path="../tools/typings/tsd.d.ts" />
var Common;
(function (Common) {
    var Module = (function () {
        function Module(name, modules) {
            this.app = angular.module(name, modules);
            this.name = name;
        }
        Module.prototype.addController = function (name, controller) {
            this.app.controller(name, controller);
        };
        Module.prototype.addService = function (name, service) {
            this.app.service(name, service);
        };
        Module.prototype.addConstant = function (name, values) {
            this.app.constant(name, values);
        };
        Module.prototype.addConfig = function (configs) {
            this.app.config(configs);
        };
        Module.prototype.addDirective = function (name, directive) {
            this.app.directive(name, directive);
        };
        Module.prototype.addFilter = function (name, filter) {
            this.app.filter(name, filter);
        };
        return Module;
    })();
    Common.Module = Module;
})(Common || (Common = {}));

/// <reference path="configurableroute.ts" />
var Common;
(function (Common) {
    var RouteRecord = (function () {
        function RouteRecord($url, $configurableRoute, $layout) {
            this.$url = $url;
            this.$configurableRoute = $configurableRoute;
            this.$layout = $layout;
            this.url = $url;
            this.config = $configurableRoute;
            this.layout = $layout;
        }
        return RouteRecord;
    })();
    Common.RouteRecord = RouteRecord;
})(Common || (Common = {}));

var Common;
(function (Common) {
    var Runner = (function () {
        function Runner() {
        }
        return Runner;
    })();
    Common.Runner = Runner;
})(Common || (Common = {}));

var Common;
(function (Common) {
    var Service = (function () {
        function Service() {
        }
        return Service;
    })();
    Common.Service = Service;
})(Common || (Common = {}));

var Common;
(function (Common) {
    var AngularServices = (function () {
        function AngularServices() {
        }
        AngularServices.$state = "$state";
        AngularServices.$location = "$location";
        AngularServices.$window = "$window";
        AngularServices.$http = "$http";
        AngularServices.$timeout = "$timeout";
        AngularServices.$cacheFactory = "$cacheFactory";
        AngularServices.$scope = "$scope";
        AngularServices.$rootScope = "$rootScope";
        AngularServices.$sessionStorage = "$sessionStorage";
        AngularServices.$q = "$q";
        AngularServices.$stateProvider = "$stateProvider";
        AngularServices.$locationProvider = "$locationProvider";
        AngularServices.$provide = "$provide";
        AngularServices.$templateCache = "$templateCache";
        AngularServices.$stateParams = "$stateParams";
        AngularServices.$filter = "$filter";
        AngularServices.$modal = "$modal";
        AngularServices.$modalInstance = "$modalInstance";
        AngularServices.$sce = "$sce";
        AngularServices.$interval = "$interval";
        AngularServices.$compile = "$compile";
        return AngularServices;
    })();
    Common.AngularServices = AngularServices;
    var OAuthServices = (function () {
        function OAuthServices() {
        }
        OAuthServices.accessToken = "AccessToken";
        OAuthServices.endpoint = "Endpoint";
        return OAuthServices;
    })();
    Common.OAuthServices = OAuthServices;
    var OtherServices = (function () {
        function OtherServices() {
        }
        OtherServices.toastr = "toastr";
        return OtherServices;
    })();
    Common.OtherServices = OtherServices;
})(Common || (Common = {}));

var App;
(function (App) {
    var Settings;
    (function (Settings) {
        var Controllers = (function () {
            function Controllers() {
            }
            Controllers.academyDashboardController = "AcademyDashboardController";
            Controllers.adminController = "AdminController";
            Controllers.categoryController = "CategoryController";
            Controllers.courseController = "CourseController";
            Controllers.dashboardController = "DashboardController";
            Controllers.error404Controller = "Error404Controller";
            Controllers.inviteUserController = "InviteUserController";
            Controllers.loginController = "LoginController";
            Controllers.mainController = "MainController";
            Controllers.menuController = "MenuController";
            Controllers.modelMigrationController = "ModelMigrationController";
            Controllers.registerController = "RegisterController";
            Controllers.trialConversionController = "TrialConversionController";
            Controllers.userDetailsController = "UserDetailsController";
            Controllers.userProfileController = "UserProfileController";
            Controllers.usersController = "UsersController";
            Controllers.deleteUserController = "DeleteUserController";
            Controllers.notImplementedController = "NotImplementedController";
            Controllers.unauthorizedController = "UnauthorizedController";
            Controllers.settingsController = "SettingsController";
            Controllers.facilityConfigurationsController = "FacilityConfigurationsController";
            Controllers.workspaceConfigurationsController = "WorkspaceConfigurationsController";
            Controllers.workspaceTypesController = "WorkspaceTypesController";
            Controllers.workspaceTypeWidgetsController = "WorkspaceTypeWidgetsController";
            Controllers.widgetDetailsController = "WidgetDetailsController";
            Controllers.widgetPublishDetailsController = "WidgetPublishDetailsController";
            return Controllers;
        })();
        Settings.Controllers = Controllers;
        var Services = (function () {
            function Services() {
            }
            Services.httpHandlerService = "HttpHandlerService";
            Services.accountService = "AccountService";
            Services.courseService = "CourseService";
            Services.dashboardService = "DashboardService";
            Services.dundasService = "DundasService";
            Services.locationService = "LocationService";
            Services.modelMigrationService = "ModelMigrationService";
            Services.notificationService = "NotificationService";
            Services.organisationService = "OrganisationService";
            Services.projectService = "ProjectService";
            Services.resourceService = "ResourceService";
            Services.subscriptionService = "SubscriptionService";
            Services.usersService = "UsersService";
            Services.authenticationService = "AuthenticationService";
            Services.pingService = "PingService";
            Services.pageTracker = "PageTracker";
            Services.widgetFactory = "WidgetFactory";
            Services.userSettingsService = "UserSettingsService";
            Services.clientSettingsService = "ClientSettingsService";
            Services.workspaceService = "WorkspaceService";
            Services.siteService = "SiteService";
            return Services;
        })();
        Settings.Services = Services;
        var Filters = (function () {
            function Filters() {
            }
            Filters.offset = "offset";
            Filters.secondsToTime = "secondsToTime";
            return Filters;
        })();
        Settings.Filters = Filters;
        var Directives = (function () {
            function Directives() {
            }
            Directives.ladda = "ladda";
            Directives.objectRequired = "objectRequired";
            Directives.rcSubmit = "rcSubmit";
            Directives.statisticMultiValueTile = "statisticMultiValueTile";
            Directives.statisticSingleValueTile = "statisticSingleValueTile";
            Directives.widgetContainer = "widgetContainer";
            return Directives;
        })();
        Settings.Directives = Directives;
    })(Settings = App.Settings || (App.Settings = {}));
})(App || (App = {}));

var App;
(function (App) {
    var Settings;
    (function (Settings) {
        var Events = (function () {
            function Events() {
            }
            Events.clientsRetrieving = "clientsRetrieving";
            Events.unauthorizedAccessDetected = "unauthorizedAccessDetected";
            Events.clientsRetrieved = "clientsRetrieved";
            Events.userRetrieved = "userRetrieved";
            Events.facilityChanged = "facilityChanged";
            Events.refreshRequested = "refreshRequested";
            Events.workspaceLoaded = "workspaceLoaded";
            Events.workspacesLoaded = "workspacesLoaded";
            Events.facilityClientConfigurationsLoaded = "facilityClientConfigurationsLoaded";
            Events.locationChanged = "locationChanged";
            return Events;
        })();
        Settings.Events = Events;
    })(Settings = App.Settings || (App.Settings = {}));
})(App || (App = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var ngs = Common.AngularServices;
    var ExceptionHandlerConfig = (function (_super) {
        __extends(ExceptionHandlerConfig, _super);
        function ExceptionHandlerConfig($provide) {
            _super.call(this);
            this.provide = $provide;
            this.provide.decorator("$exceptionHandler", [
                "$delegate", function ($delegate) { return function (exception, cause) {
                    if (window.useRaygun) {
                        window.Raygun.send(exception);
                    }
                    $delegate(exception, cause);
                }; }]);
        }
        ExceptionHandlerConfig.$inject = [ngs.$provide];
        return ExceptionHandlerConfig;
    })(Common.Config);
    App.ExceptionHandlerConfig = ExceptionHandlerConfig;
})(App || (App = {}));

/// <reference path="../../tools/typings/tsd.d.ts" />
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var ngs = Common.AngularServices;
    var MainRunner = (function (_super) {
        __extends(MainRunner, _super);
        function MainRunner($templateCache, $rootScope, $state, $stateParams, $location, $sessionStorage, $http, notificationService, authenticationService, pingService) {
            _super.call(this);
            $rootScope.$on("$stateChangeSuccess", function (event, toState) {
                // Sets the layout name, which can be used to display different layouts (header, footer etc.)
                // based on which page the user is located
                $rootScope.layout = toState.layout;
            });
            // Allows to retrieve UI Router state information from inside templates
            $rootScope.$state = $state;
            $rootScope.$stateParams = $stateParams;
            $rootScope.$on("$stateChangeStart", function (event, toState) {
                var requireLogin = toState.data && toState.data.requireLogin;
                // Check if user is logged in and all data is loaded
                if (authenticationService.isLoggedin()) {
                    if (toState.name !== "unauthorized") {
                        authenticationService.checkClientAccess();
                        return;
                    }
                }
                // Check if user is logged in but token is not set on rootscope
                if (requireLogin && !authenticationService.isLoggedin() && authenticationService.getToken()) {
                    authenticationService.login();
                    return;
                }
                // Check if user is fully logged in
                if (requireLogin && !authenticationService.isLoggedin()) {
                    authenticationService.login();
                    //pingService.ping();
                    return;
                }
                if (requireLogin && authenticationService.isLoggedin() && authenticationService.isExpired()) {
                    authenticationService.logout(null);
                    return;
                }
                if (toState.name === "login") {
                    window.location.href = "/dashboard";
                    return;
                }
                if (authenticationService.isLoggedin() && toState.name === "login") {
                    window.location.href = "/dashboard";
                }
            });
        }
        MainRunner.$inject = [ngs.$templateCache, ngs.$rootScope, ngs.$state, ngs.$stateParams, ngs.$location, ngs.$sessionStorage, ngs.$http, App.Settings.Services.notificationService, App.Settings.Services.authenticationService, App.Settings.Services.pingService];
        return MainRunner;
    })(Common.Runner);
    App.MainRunner = MainRunner;
})(App || (App = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var ngs = Common.AngularServices;
    var Controllers = App.Settings.Controllers;
    var AppRoutes = (function (_super) {
        __extends(AppRoutes, _super);
        function AppRoutes($stateProvider, $locationProvider) {
            _super.call(this);
            this.locationProvider = $locationProvider;
            this.stateProvider = $stateProvider;
            this.stateProvider.state("dashboard", new App.State("/dashboard", "/wwwroot/views/home/dashboard.html", Controllers.dashboardController, new App.StateConfigurations(true)));
            this.stateProvider.state("settings", new App.State("/settings", "/wwwroot/views/settings/settings.html", Controllers.settingsController, new App.StateConfigurations(true)));
            this.stateProvider.state("facilityConfigurations", new App.State("/facility-configurations/{mode}", "/wwwroot/views/settings/facilityConfigurations.html", Controllers.facilityConfigurationsController, new App.StateConfigurations(true)));
            this.stateProvider.state("workspaceTypes", new App.State("/workspace-types", "/wwwroot/views/settings/workspaceTypes.html", Controllers.workspaceTypesController, new App.StateConfigurations(true)));
            this.stateProvider.state("workspaceTypeWidgets", new App.State("/workspace-type-widgets/{workspaceType}", "/wwwroot/views/settings/workspaceTypeWidgets.html", Controllers.workspaceTypeWidgetsController, new App.StateConfigurations(true)));
            this.stateProvider.state("login", new App.State("/", "/wwwroot/views/home/login.html", Controllers.loginController, new App.StateConfigurations(true), "basic"));
            this.stateProvider.state("unauthorized", new App.State("*path", "/wwwroot/views/error/unauthorized.html", Controllers.unauthorizedController));
            this.stateProvider.state("otherwise", new App.State("*path", "/wwwroot/views/error/404.html", Controllers.error404Controller));
            this.locationProvider.html5Mode(true);
        }
        AppRoutes.$inject = [ngs.$stateProvider, ngs.$locationProvider];
        return AppRoutes;
    })(Common.Config);
    App.AppRoutes = AppRoutes;
})(App || (App = {}));

var App;
(function (App) {
    var ValidationResult = (function () {
        function ValidationResult(result, message) {
            this.result = result;
            this.message = message;
        }
        return ValidationResult;
    })();
    App.ValidationResult = ValidationResult;
})(App || (App = {}));

var App;
(function (App) {
    var NausUser = (function () {
        function NausUser() {
        }
        return NausUser;
    })();
    App.NausUser = NausUser;
    var AdditionalInfo = (function () {
        function AdditionalInfo() {
        }
        return AdditionalInfo;
    })();
    App.AdditionalInfo = AdditionalInfo;
    var AccountDirectory = (function () {
        function AccountDirectory() {
        }
        return AccountDirectory;
    })();
    App.AccountDirectory = AccountDirectory;
    var Location = (function () {
        function Location() {
        }
        return Location;
    })();
    App.Location = Location;
})(App || (App = {}));

var App;
(function (App) {
    var State = (function () {
        function State(url, templateUrl, controller, data, layout) {
            this.data = data;
            this.controller = controller;
            this.templateUrl = templateUrl;
            this.url = url;
            this.layout = layout;
        }
        return State;
    })();
    App.State = State;
    var StateConfigurations = (function () {
        function StateConfigurations(requireLogin) {
            this.requireLogin = requireLogin;
        }
        return StateConfigurations;
    })();
    App.StateConfigurations = StateConfigurations;
})(App || (App = {}));

var App;
(function (App) {
    var User = (function () {
        function User() {
        }
        return User;
    })();
    App.User = User;
    var Contact = (function () {
        function Contact(email, firstName, lastName) {
            this.email = email;
            this.firstName = firstName;
            this.lastName = lastName;
        }
        return Contact;
    })();
    App.Contact = Contact;
})(App || (App = {}));

var App;
(function (App) {
    var GeWorkspaceTypeWidgetsResponse = (function () {
        function GeWorkspaceTypeWidgetsResponse() {
        }
        return GeWorkspaceTypeWidgetsResponse;
    })();
    App.GeWorkspaceTypeWidgetsResponse = GeWorkspaceTypeWidgetsResponse;
})(App || (App = {}));

var App;
(function (App) {
    var GeWorkspaceTypesResponse = (function () {
        function GeWorkspaceTypesResponse() {
        }
        return GeWorkspaceTypesResponse;
    })();
    App.GeWorkspaceTypesResponse = GeWorkspaceTypesResponse;
})(App || (App = {}));

var App;
(function (App) {
    var GetAvailableDashboardsResponse = (function () {
        function GetAvailableDashboardsResponse() {
        }
        return GetAvailableDashboardsResponse;
    })();
    App.GetAvailableDashboardsResponse = GetAvailableDashboardsResponse;
})(App || (App = {}));

var App;
(function (App) {
    var GetAverageProcessingTimeResponse = (function () {
        function GetAverageProcessingTimeResponse() {
        }
        return GetAverageProcessingTimeResponse;
    })();
    App.GetAverageProcessingTimeResponse = GetAverageProcessingTimeResponse;
})(App || (App = {}));

var App;
(function (App) {
    var GetClientDetailsResponse = (function () {
        function GetClientDetailsResponse() {
        }
        return GetClientDetailsResponse;
    })();
    App.GetClientDetailsResponse = GetClientDetailsResponse;
})(App || (App = {}));



var App;
(function (App) {
    var GetInboundTonnagesByMonthResponse = (function () {
        function GetInboundTonnagesByMonthResponse() {
        }
        return GetInboundTonnagesByMonthResponse;
    })();
    App.GetInboundTonnagesByMonthResponse = GetInboundTonnagesByMonthResponse;
})(App || (App = {}));

var App;
(function (App) {
    var GetOutboundTonnagesByMonthResponse = (function () {
        function GetOutboundTonnagesByMonthResponse() {
        }
        return GetOutboundTonnagesByMonthResponse;
    })();
    App.GetOutboundTonnagesByMonthResponse = GetOutboundTonnagesByMonthResponse;
})(App || (App = {}));

var App;
(function (App) {
    var GetRevenueStatisticsByDayOfWeekResponse = (function () {
        function GetRevenueStatisticsByDayOfWeekResponse() {
        }
        return GetRevenueStatisticsByDayOfWeekResponse;
    })();
    App.GetRevenueStatisticsByDayOfWeekResponse = GetRevenueStatisticsByDayOfWeekResponse;
    var RevenueDataPoint = (function () {
        function RevenueDataPoint() {
        }
        return RevenueDataPoint;
    })();
    App.RevenueDataPoint = RevenueDataPoint;
})(App || (App = {}));

var App;
(function (App) {
    var GetSiteLocationsResponse = (function () {
        function GetSiteLocationsResponse() {
        }
        return GetSiteLocationsResponse;
    })();
    App.GetSiteLocationsResponse = GetSiteLocationsResponse;
})(App || (App = {}));



var App;
(function (App) {
    var GetStatisticsByDayOfWeekResponse = (function () {
        function GetStatisticsByDayOfWeekResponse() {
        }
        return GetStatisticsByDayOfWeekResponse;
    })();
    App.GetStatisticsByDayOfWeekResponse = GetStatisticsByDayOfWeekResponse;
})(App || (App = {}));

var App;
(function (App) {
    var GetStatisticsByDayResponse = (function () {
        function GetStatisticsByDayResponse() {
        }
        return GetStatisticsByDayResponse;
    })();
    App.GetStatisticsByDayResponse = GetStatisticsByDayResponse;
})(App || (App = {}));

var App;
(function (App) {
    var GetStatisticsByHourOfDayResponse = (function () {
        function GetStatisticsByHourOfDayResponse() {
        }
        return GetStatisticsByHourOfDayResponse;
    })();
    App.GetStatisticsByHourOfDayResponse = GetStatisticsByHourOfDayResponse;
})(App || (App = {}));

var App;
(function (App) {
    var GetStatisticsByWeekResponse = (function () {
        function GetStatisticsByWeekResponse() {
        }
        return GetStatisticsByWeekResponse;
    })();
    App.GetStatisticsByWeekResponse = GetStatisticsByWeekResponse;
})(App || (App = {}));

var App;
(function (App) {
    var GetTonnagesVsRevenueDetailsResponse = (function () {
        function GetTonnagesVsRevenueDetailsResponse() {
        }
        return GetTonnagesVsRevenueDetailsResponse;
    })();
    App.GetTonnagesVsRevenueDetailsResponse = GetTonnagesVsRevenueDetailsResponse;
    var TonnagesVsRevenueDataPoint = (function () {
        function TonnagesVsRevenueDataPoint() {
        }
        return TonnagesVsRevenueDataPoint;
    })();
    App.TonnagesVsRevenueDataPoint = TonnagesVsRevenueDataPoint;
})(App || (App = {}));

var App;
(function (App) {
    var GetTopCustomersByRevenueByMonthResponse = (function () {
        function GetTopCustomersByRevenueByMonthResponse() {
        }
        return GetTopCustomersByRevenueByMonthResponse;
    })();
    App.GetTopCustomersByRevenueByMonthResponse = GetTopCustomersByRevenueByMonthResponse;
})(App || (App = {}));

var App;
(function (App) {
    var GetTopProductsByRevenueByMonthResponse = (function () {
        function GetTopProductsByRevenueByMonthResponse() {
        }
        return GetTopProductsByRevenueByMonthResponse;
    })();
    App.GetTopProductsByRevenueByMonthResponse = GetTopProductsByRevenueByMonthResponse;
})(App || (App = {}));

var App;
(function (App) {
    var GetTotalRevenueByMonthResponse = (function () {
        function GetTotalRevenueByMonthResponse() {
        }
        return GetTotalRevenueByMonthResponse;
    })();
    App.GetTotalRevenueByMonthResponse = GetTotalRevenueByMonthResponse;
})(App || (App = {}));

var App;
(function (App) {
    var GetTotalTonnagesByMonthResponse = (function () {
        function GetTotalTonnagesByMonthResponse() {
        }
        return GetTotalTonnagesByMonthResponse;
    })();
    App.GetTotalTonnagesByMonthResponse = GetTotalTonnagesByMonthResponse;
})(App || (App = {}));

var App;
(function (App) {
    var GetTotalTonnagesVsRevenueByMonthResponse = (function () {
        function GetTotalTonnagesVsRevenueByMonthResponse() {
        }
        return GetTotalTonnagesVsRevenueByMonthResponse;
    })();
    App.GetTotalTonnagesVsRevenueByMonthResponse = GetTotalTonnagesVsRevenueByMonthResponse;
})(App || (App = {}));

var App;
(function (App) {
    var GetTransactionCountsByMonthResponse = (function () {
        function GetTransactionCountsByMonthResponse() {
        }
        return GetTransactionCountsByMonthResponse;
    })();
    App.GetTransactionCountsByMonthResponse = GetTransactionCountsByMonthResponse;
})(App || (App = {}));

var App;
(function (App) {
    var GetUserWorkspaceDetailsResponse = (function () {
        function GetUserWorkspaceDetailsResponse() {
        }
        return GetUserWorkspaceDetailsResponse;
    })();
    App.GetUserWorkspaceDetailsResponse = GetUserWorkspaceDetailsResponse;
})(App || (App = {}));

var App;
(function (App) {
    var GetUserWorkspacesResponse = (function () {
        function GetUserWorkspacesResponse() {
        }
        return GetUserWorkspacesResponse;
    })();
    App.GetUserWorkspacesResponse = GetUserWorkspacesResponse;
})(App || (App = {}));

var App;
(function (App) {
    var GetValueResponse = (function () {
        function GetValueResponse() {
        }
        return GetValueResponse;
    })();
    App.GetValueResponse = GetValueResponse;
})(App || (App = {}));



var App;
(function (App) {
    var TransactionSearchResponse = (function () {
        function TransactionSearchResponse() {
        }
        return TransactionSearchResponse;
    })();
    App.TransactionSearchResponse = TransactionSearchResponse;
})(App || (App = {}));

var App;
(function (App) {
    var CancelledChangedTransactionsTableObject = (function () {
        function CancelledChangedTransactionsTableObject() {
            this.dataRows = [];
            this.type = "Table",
                this.data = {
                    cols: [
                        {
                            id: "time",
                            label: "Time",
                            type: "string",
                            p: {}
                        },
                        {
                            id: "operator",
                            label: "Operator",
                            type: "string",
                            p: {}
                        },
                        {
                            id: "client",
                            label: "Client",
                            type: "string",
                            p: {}
                        },
                        {
                            id: "ticket",
                            label: "Ticket",
                            type: "string",
                            p: {}
                        },
                        {
                            id: "action",
                            label: "Action",
                            type: "string",
                            p: {}
                        },
                        {
                            id: "reason",
                            label: "Reason",
                            type: "string",
                            p: {}
                        }
                    ],
                    rows: this.dataRows,
                    p: null
                };
            this.options = {
                width: "100%",
                allowHtml: true,
                cssClassNames: {
                    headerRow: "panelTableHeaderRow",
                    tableRow: "panelTableRow",
                    headerCell: "panelTableHeaderCell",
                    oddTableRow: "panelTableRow"
                },
                sortColumn: 0
            };
        }
        CancelledChangedTransactionsTableObject.prototype.load = function (chartData) {
            var that = this;
            that.dataRows.length = 0;
            var dataCells = Enumerable.From(chartData)
                .Select(function (v) {
                var reasonTemplate = "<a href=\"#\" data-toggle=\"tooltip\" data-trigger=\"click\" data-placement=\"auto\" class=\"reason-view\" title=\"" + (v.CancelReplaceNotes || "no data") + "\"><span class=\"fa fa-question-circle-o\"></span></a>";
                return {
                    c: [
                        { v: v.Time },
                        { v: v.OperatorName },
                        { v: v.ClientName },
                        { v: v.TicketNumber },
                        { v: v.Replaced ? "Revised" : "Cancelled" },
                        { v: reasonTemplate }
                    ]
                };
            })
                .ToArray();
            angular.forEach(dataCells, function (value) {
                that.dataRows.push(value);
            });
        };
        return CancelledChangedTransactionsTableObject;
    })();
    App.CancelledChangedTransactionsTableObject = CancelledChangedTransactionsTableObject;
})(App || (App = {}));



var App;
(function (App) {
    var ChartObjectHelper;
    (function (ChartObjectHelper) {
        function applyMinimum(displayValue, minimumDisplayValue) {
            if (displayValue > 0 && displayValue < minimumDisplayValue) {
                return minimumDisplayValue;
            }
            else if (displayValue < 0 && displayValue > -minimumDisplayValue) {
                return -minimumDisplayValue;
            }
            return displayValue;
        }
        ChartObjectHelper.applyMinimum = applyMinimum;
    })(ChartObjectHelper = App.ChartObjectHelper || (App.ChartObjectHelper = {}));
})(App || (App = {}));

var App;
(function (App) {
    var CurentVsPreviousData = (function () {
        function CurentVsPreviousData() {
        }
        CurentVsPreviousData.prototype.toTwoSeriesData = function () {
            return {
                label: this.Label,
                firstValue: this.PreviousYearValue,
                secondValue: this.CurrentYearValue,
                date: this.Id
            };
        };
        return CurentVsPreviousData;
    })();
    App.CurentVsPreviousData = CurentVsPreviousData;
})(App || (App = {}));

var App;
(function (App) {
    var Daily30DaysRevenueDetailsTableObject = (function () {
        function Daily30DaysRevenueDetailsTableObject() {
            this.dataRows = [];
            this.type = "Table",
                this.data = {
                    cols: [
                        {
                            id: "time",
                            label: "Time",
                            type: "string",
                            p: {}
                        },
                        {
                            id: "product",
                            label: "Product",
                            type: "string",
                            p: {}
                        },
                        {
                            id: "customer",
                            label: "Customer",
                            type: "string",
                            p: {}
                        },
                        {
                            id: "price",
                            label: "Price",
                            type: "number",
                            p: {}
                        },
                        {
                            id: "ticket",
                            label: "Ticket",
                            type: "string",
                            p: {}
                        }
                    ],
                    rows: this.dataRows,
                    p: null
                };
            this.options = {
                width: "100%",
                cssClassNames: {
                    headerRow: "panelTableHeaderRow",
                    tableRow: "panelTableRow",
                    headerCell: "panelTableHeaderCell",
                    oddTableRow: "panelTableRow"
                },
                sortColumn: 0
            };
        }
        Daily30DaysRevenueDetailsTableObject.prototype.load = function (chartData) {
            var that = this;
            that.dataRows.length = 0;
            var dataCells = Enumerable.From(chartData)
                .Select(function (v) {
                return {
                    c: [
                        { v: v.Time },
                        { v: v.ProductName },
                        { v: v.CustomerName },
                        { v: v.Price },
                        { v: v.TicketId }
                    ]
                };
            })
                .ToArray();
            angular.forEach(dataCells, function (value) {
                that.dataRows.push(value);
            });
        };
        return Daily30DaysRevenueDetailsTableObject;
    })();
    App.Daily30DaysRevenueDetailsTableObject = Daily30DaysRevenueDetailsTableObject;
})(App || (App = {}));

var App;
(function (App) {
    var DailyTickedDetailsTableObject = (function () {
        function DailyTickedDetailsTableObject() {
            this.dataRows = [];
            this.type = "Table",
                this.data = {
                    cols: [
                        {
                            id: "time",
                            label: "Time",
                            type: "string",
                            p: {}
                        },
                        {
                            id: "product",
                            label: "Product",
                            type: "string",
                            p: {}
                        },
                        {
                            id: "customer",
                            label: "Customer",
                            type: "string",
                            p: {}
                        },
                        {
                            id: "price",
                            label: "Price",
                            type: "number",
                            p: {}
                        },
                        {
                            id: "tonnage",
                            label: "Tonnages",
                            type: "number",
                            p: {}
                        },
                        {
                            id: "ticket",
                            label: "Ticket",
                            type: "string",
                            p: {}
                        }
                    ],
                    rows: this.dataRows,
                    p: null
                };
            this.options = {
                width: "100%",
                cssClassNames: {
                    headerRow: "panelTableHeaderRow",
                    tableRow: "panelTableRow",
                    headerCell: "panelTableHeaderCell",
                    oddTableRow: "panelTableRow"
                },
                sortColumn: 0
            };
        }
        DailyTickedDetailsTableObject.prototype.load = function (chartData) {
            var that = this;
            that.dataRows.length = 0;
            var dataCells = Enumerable.From(chartData)
                .Select(function (v) {
                return {
                    c: [
                        { v: v.Time },
                        { v: v.ProductName },
                        { v: v.CustomerName },
                        { v: v.Price },
                        { v: v.Tonnage },
                        { v: v.TicketId }
                    ]
                };
            })
                .ToArray();
            angular.forEach(dataCells, function (value) {
                that.dataRows.push(value);
            });
        };
        return DailyTickedDetailsTableObject;
    })();
    App.DailyTickedDetailsTableObject = DailyTickedDetailsTableObject;
})(App || (App = {}));

var App;
(function (App) {
    var MeasuresComparisonData = (function () {
        function MeasuresComparisonData() {
        }
        return MeasuresComparisonData;
    })();
    App.MeasuresComparisonData = MeasuresComparisonData;
})(App || (App = {}));

var App;
(function (App) {
    var OneSeriesChartObject = (function () {
        function OneSeriesChartObject(configs) {
            this.dataRows = [];
            this.type = configs.chartType,
                this.data = {
                    cols: [
                        {
                            id: "day",
                            label: "Day",
                            type: "string",
                            p: {}
                        },
                        {
                            id: "id1",
                            label: configs.column1Title,
                            type: "number",
                            p: {}
                        }
                    ],
                    rows: this.dataRows,
                    p: null
                };
            this.options = {
                title: configs.title,
                isStacked: configs.isStacked || false,
                vAxis: {
                    title: configs.vAxisTitle,
                    minValue: configs.minValue || 0,
                    gridlines: {
                        "count": 10
                    }
                },
                hAxis: {
                    title: configs.hAxisTitle
                },
                legend: configs.legendSetting || { position: "none", height: "100%" },
                chartArea: { left: 10, top: 10, width: "90%", height: "90%" },
                animation: { duration: 1500 },
                colors: configs.colors || App.Palettes.defaultPalette
            };
            this.formatters = {
                number: [
                    {
                        columnNum: 1,
                        pattern: configs.numberFormat
                    }
                ]
            };
        }
        OneSeriesChartObject.prototype.load = function (chartData) {
            var that = this;
            // clear data
            that.dataRows.length = 0;
            var maximumDataValue = Enumerable.From(chartData).Max(function (v) { return Math.abs(v.value); });
            var minimumDisplayValue = maximumDataValue / 100.0;
            var dataCells = Enumerable.From(chartData)
                .Select(function (v) {
                var chartRow = {
                    c: [
                        { v: v.label },
                        { v: App.ChartObjectHelper.applyMinimum(v.value, minimumDisplayValue) }
                    ]
                };
                if (v.date) {
                    chartRow.id = v.date;
                }
                if (v.dateFormatted) {
                    chartRow.label = v.dateFormatted;
                }
                return chartRow;
            })
                .ToArray();
            angular.forEach(dataCells, function (value) {
                that.dataRows.push(value);
            });
        };
        return OneSeriesChartObject;
    })();
    App.OneSeriesChartObject = OneSeriesChartObject;
})(App || (App = {}));



var App;
(function (App) {
    var Portion = (function () {
        function Portion() {
        }
        return Portion;
    })();
    App.Portion = Portion;
})(App || (App = {}));

var App;
(function (App) {
    var StatisticData = (function () {
        function StatisticData() {
        }
        StatisticData.prototype.toTwoSeriesData = function () {
            return {
                date: this.Date,
                dateFormatted: this.DateFormatted,
                label: this.Label,
                totalValue: this.Count,
                firstValue: this.CancelledCount,
                secondValue: this.ChangedCount
            };
        };
        return StatisticData;
    })();
    App.StatisticData = StatisticData;
})(App || (App = {}));

var App;
(function (App) {
    var TwoSeriesChartObject = (function () {
        function TwoSeriesChartObject(configs) {
            this.dataRows = [];
            this.type = configs.chartType,
                this.data = {
                    cols: [
                        {
                            id: "day",
                            label: "Day",
                            type: "string",
                            p: {}
                        },
                        {
                            id: "id1",
                            label: configs.column1Title,
                            type: "number",
                            p: {}
                        },
                        {
                            id: "id2",
                            label: configs.column2Title,
                            type: "number",
                            p: {}
                        }
                    ],
                    rows: this.dataRows,
                    p: null
                };
            this.options = {
                title: configs.title,
                isStacked: configs.isStacked || false,
                vAxis: {
                    title: configs.vAxisTitle,
                    minValue: configs.minValue || 0,
                    gridlines: {
                        "count": 10
                    }
                },
                hAxis: {
                    title: configs.hAxisTitle
                },
                legend: { position: "bottom" },
                chartArea: { left: 50, top: 50, width: "90%" },
                animation: { duration: 1500 },
                colors: configs.colors || App.Palettes.defaultPalette
            };
            this.formatters = {
                number: [
                    {
                        columnNum: 1,
                        pattern: configs.numberFormat
                    }, {
                        columnNum: 2,
                        pattern: configs.numberFormat
                    }
                ]
            };
        }
        TwoSeriesChartObject.prototype.load = function (chartData) {
            var that = this;
            // clear data
            that.dataRows.length = 0;
            var maximumDataValue = Enumerable.From(chartData).Max(function (v) { return Math.max(Math.abs(v.firstValue), Math.abs(v.secondValue)); });
            var minimumDisplayValue = maximumDataValue / 100.0;
            var dataCells = Enumerable.From(chartData)
                .Select(function (v) {
                var chartRow = {
                    c: [
                        { v: v.label },
                        { v: App.ChartObjectHelper.applyMinimum(v.firstValue, minimumDisplayValue) },
                        { v: App.ChartObjectHelper.applyMinimum(v.secondValue, minimumDisplayValue) }
                    ]
                };
                if (v.date) {
                    chartRow.id = v.date;
                }
                if (v.dateFormatted) {
                    chartRow.label = v.dateFormatted;
                }
                return chartRow;
            })
                .ToArray();
            angular.forEach(dataCells, function (value) {
                that.dataRows.push(value);
            });
        };
        return TwoSeriesChartObject;
    })();
    App.TwoSeriesChartObject = TwoSeriesChartObject;
})(App || (App = {}));



var App;
(function (App) {
    var ClientDetails = (function () {
        function ClientDetails() {
        }
        return ClientDetails;
    })();
    App.ClientDetails = ClientDetails;
})(App || (App = {}));



var App;
(function (App) {
    var FacilityDetails = (function () {
        function FacilityDetails() {
        }
        return FacilityDetails;
    })();
    App.FacilityDetails = FacilityDetails;
})(App || (App = {}));





var App;
(function (App) {
    var SiteDetails = (function () {
        function SiteDetails() {
        }
        return SiteDetails;
    })();
    App.SiteDetails = SiteDetails;
})(App || (App = {}));



var App;
(function (App) {
    (function (FacilityType) {
        FacilityType[FacilityType["Landfill"] = 1] = "Landfill";
        FacilityType[FacilityType["TransferStation"] = 2] = "TransferStation";
        FacilityType[FacilityType["TipShop"] = 3] = "TipShop";
        FacilityType[FacilityType["MRF"] = 4] = "MRF";
        FacilityType[FacilityType["Quarry"] = 5] = "Quarry";
        FacilityType[FacilityType["Other"] = 99] = "Other";
    })(App.FacilityType || (App.FacilityType = {}));
    var FacilityType = App.FacilityType;
})(App || (App = {}));

var App;
(function (App) {
    var WidgetDetails = (function () {
        function WidgetDetails() {
        }
        return WidgetDetails;
    })();
    App.WidgetDetails = WidgetDetails;
    var TypeLookup = (function () {
        function TypeLookup(type, label) {
            this.value = type;
            this.label = label;
        }
        return TypeLookup;
    })();
    App.TypeLookup = TypeLookup;
    var StyleLookup = (function () {
        function StyleLookup(style, label) {
            this.value = style;
            this.label = label;
        }
        return StyleLookup;
    })();
    App.StyleLookup = StyleLookup;
})(App || (App = {}));

var App;
(function (App) {
    (function (WidgetType) {
        WidgetType[WidgetType["Rolling30DaysRevenueVsSamePeriodLastYear"] = 1] = "Rolling30DaysRevenueVsSamePeriodLastYear";
        WidgetType[WidgetType["Rolling30DaysTonnagesVsSamePeriodLastYear"] = 2] = "Rolling30DaysTonnagesVsSamePeriodLastYear";
        WidgetType[WidgetType["Rolling30DaysTransactionCountsVsSamePeriodLastYear"] = 3] = "Rolling30DaysTransactionCountsVsSamePeriodLastYear";
        WidgetType[WidgetType["AverageTransactionProcessingTime"] = 4] = "AverageTransactionProcessingTime";
        WidgetType[WidgetType["Rolling7DaysCancelledAndAmendedTransactions"] = 5] = "Rolling7DaysCancelledAndAmendedTransactions";
        WidgetType[WidgetType["DailyCancelledAndAmendedTransactionsDetails"] = 6] = "DailyCancelledAndAmendedTransactionsDetails";
        WidgetType[WidgetType["Rolling6MonthsWeeklyTransactionCount"] = 7] = "Rolling6MonthsWeeklyTransactionCount";
        WidgetType[WidgetType["Rolling6MonthsAvgWeekdayTransactionCount"] = 8] = "Rolling6MonthsAvgWeekdayTransactionCount";
        WidgetType[WidgetType["Rolling6MonthsAvgHoulyTransactionCount"] = 9] = "Rolling6MonthsAvgHoulyTransactionCount";
        WidgetType[WidgetType["TopTenProductsByRevenue"] = 10] = "TopTenProductsByRevenue";
        WidgetType[WidgetType["TopTenCustomersByRevenue"] = 11] = "TopTenCustomersByRevenue";
        WidgetType[WidgetType["Daily30DaysRevenueDetails"] = 12] = "Daily30DaysRevenueDetails";
        WidgetType[WidgetType["Rolling30DaysInboundTonnagesVsSamePeriodLastYear"] = 13] = "Rolling30DaysInboundTonnagesVsSamePeriodLastYear";
        WidgetType[WidgetType["Rolling30DaysOutboundTonnagesVsSamePeriodLastYear"] = 14] = "Rolling30DaysOutboundTonnagesVsSamePeriodLastYear";
        WidgetType[WidgetType["NumberOfOperatorErrors"] = 15] = "NumberOfOperatorErrors";
        WidgetType[WidgetType["Rolling30DaysTonnagesVsRevenue"] = 16] = "Rolling30DaysTonnagesVsRevenue";
        WidgetType[WidgetType["TotalRollingRevenue"] = 17] = "TotalRollingRevenue";
        WidgetType[WidgetType["TotalRollingTonnage"] = 18] = "TotalRollingTonnage";
        WidgetType[WidgetType["Daily30DaysTonnagesVsRevenueDetails"] = 19] = "Daily30DaysTonnagesVsRevenueDetails";
        WidgetType[WidgetType["Generic"] = 20] = "Generic";
    })(App.WidgetType || (App.WidgetType = {}));
    var WidgetType = App.WidgetType;
    (function (WidgetStyle) {
        WidgetStyle[WidgetStyle["BarChart"] = 1] = "BarChart";
        WidgetStyle[WidgetStyle["LineChart"] = 2] = "LineChart";
        WidgetStyle[WidgetStyle["AreaChart"] = 3] = "AreaChart";
        WidgetStyle[WidgetStyle["StackedChart"] = 4] = "StackedChart";
        WidgetStyle[WidgetStyle["ColumnChart"] = 5] = "ColumnChart";
        WidgetStyle[WidgetStyle["Number"] = 6] = "Number";
        WidgetStyle[WidgetStyle["Table"] = 7] = "Table";
        WidgetStyle[WidgetStyle["PieChart"] = 8] = "PieChart";
        WidgetStyle[WidgetStyle["Custom"] = 9] = "Custom";
    })(App.WidgetStyle || (App.WidgetStyle = {}));
    var WidgetStyle = App.WidgetStyle;
    (function (DataSourceType) {
        DataSourceType[DataSourceType["MandalayCsWarehouse"] = 1] = "MandalayCsWarehouse";
        DataSourceType[DataSourceType["DundasCsWarehouse"] = 2] = "DundasCsWarehouse";
        DataSourceType[DataSourceType["SisenseCsWarehouse"] = 3] = "SisenseCsWarehouse";
        DataSourceType[DataSourceType["PowerBiCsWarehouse"] = 4] = "PowerBiCsWarehouse";
    })(App.DataSourceType || (App.DataSourceType = {}));
    var DataSourceType = App.DataSourceType;
})(App || (App = {}));

var App;
(function (App) {
    (function (WorkspaceType) {
        WorkspaceType[WorkspaceType["Landfill"] = 1] = "Landfill";
        WorkspaceType[WorkspaceType["TipShop"] = 2] = "TipShop";
        WorkspaceType[WorkspaceType["Site"] = 3] = "Site";
        WorkspaceType[WorkspaceType["Global"] = 4] = "Global";
        WorkspaceType[WorkspaceType["TransferStation"] = 5] = "TransferStation";
        WorkspaceType[WorkspaceType["MRF"] = 6] = "MRF";
        WorkspaceType[WorkspaceType["Quarry"] = 7] = "Quarry";
        WorkspaceType[WorkspaceType["Custom"] = 99] = "Custom";
    })(App.WorkspaceType || (App.WorkspaceType = {}));
    var WorkspaceType = App.WorkspaceType;
    var WorkspaceDetails = (function () {
        function WorkspaceDetails() {
        }
        return WorkspaceDetails;
    })();
    App.WorkspaceDetails = WorkspaceDetails;
    var WorkspaceTypeDetails = (function () {
        function WorkspaceTypeDetails() {
        }
        return WorkspaceTypeDetails;
    })();
    App.WorkspaceTypeDetails = WorkspaceTypeDetails;
})(App || (App = {}));

var App;
(function (App) {
    var Palettes = (function () {
        function Palettes() {
        }
        Palettes.defaultPalette = ['#2196f3', '#ff9800', '#4caf50', '#FFF59D', '#009688', '#ffc107', '#81D4FA', '#795548', '#9fa8da', '#E6EE9C', '#9e9e9e', '#00bcd4', '#C5E1A5', '#673ab7', '#ff8a65', '#607d8b', '#ef9a9a', '#e91e63', '#9c27b0', '#ce93d8'];
        Palettes.cancelledPalette = ['#D32F2F', '#2196f3', '#ff9800', '#4caf50', '#FFF59D', '#009688', '#ffc107', '#81D4FA', '#795548', '#9fa8da', '#E6EE9C', '#9e9e9e', '#00bcd4', '#C5E1A5', '#673ab7', '#ff8a65', '#607d8b', '#ef9a9a', '#e91e63', '#9c27b0', '#ce93d8'];
        Palettes.darkerPalette = ['#2196f3', '#ff9800', '#4caf50', '#009688', '#795548', '#9e9e9e', '#00bcd4', '#673ab7', '#607d8b', '#e91e63', '#9c27b0', '#C62828', '#6A1B9A', '#4527A0', '#AD1457', '#1565C0', '#283593', '#00838F', '#4E342E', '#424242'];
        return Palettes;
    })();
    App.Palettes = Palettes;
})(App || (App = {}));

var App;
(function (App) {
    var Filters = (function () {
        function Filters() {
        }
        Filters.offset = "offset";
        return Filters;
    })();
    App.Filters = Filters;
})(App || (App = {}));

var App;
(function (App) {
    function OffsetFilter() {
        return function (input, start) {
            return input.slice(start);
        };
    }
    App.OffsetFilter = OffsetFilter;
})(App || (App = {}));

var App;
(function (App) {
    function SecondsToTimeFilter() {
        return function (totalSeconds) {
            var hours = Math.floor(totalSeconds / 3600);
            var minutes = Math.floor((totalSeconds - (hours * 3600)) / 60);
            var seconds = totalSeconds - (hours * 3600) - (minutes * 60);
            var formattedTime = seconds + "s";
            if (minutes > 0) {
                formattedTime = minutes + "m " + formattedTime;
            }
            if (hours > 0) {
                formattedTime = hours + "h " + formattedTime;
            }
            return formattedTime;
        };
    }
    App.SecondsToTimeFilter = SecondsToTimeFilter;
})(App || (App = {}));

/// <reference path="../../../common/service.ts" />
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Service = Common.Service;
    var ngs = Common.AngularServices;
    var HttpHandlerService = (function (_super) {
        __extends(HttpHandlerService, _super);
        function HttpHandlerService($http, $q) {
            _super.call(this);
            this.httpService = $http;
            this.queryService = $q;
        }
        HttpHandlerService.prototype.post = function (endpoint, params, config) {
            var deffered = this.queryService.defer();
            this.httpService.post(endpoint, params, config)
                .success(function (data) {
                deffered.resolve(data);
            })
                .error(function (data) {
                deffered.reject(data);
            });
            return deffered.promise;
        };
        HttpHandlerService.prototype.put = function (endpoint, params) {
            var deffered = this.queryService.defer();
            this.httpService.put(endpoint, params)
                .success(function (data) {
                deffered.resolve(data);
            })
                .error(function (data) {
                deffered.reject(data);
            });
            return deffered.promise;
        };
        HttpHandlerService.prototype.delete = function (endpoint, params) {
            var deffered = this.queryService.defer();
            this.httpService.delete(endpoint, params)
                .success(function (data) {
                deffered.resolve(data);
            })
                .error(function (data) {
                deffered.reject(data);
            });
            return deffered.promise;
        };
        HttpHandlerService.prototype.get = function (endpoint, stored) {
            var deffered = this.queryService.defer();
            if (stored) {
                deffered.resolve(stored);
                return deffered.promise;
            }
            this.httpService.get(endpoint)
                .success(function (data) {
                deffered.resolve(data);
            })
                .error(function (data) {
                deffered.reject(data);
            });
            return deffered.promise;
        };
        HttpHandlerService.prototype.getWithConfig = function (endpoint, config) {
            var deffered = this.queryService.defer();
            this.httpService.get(endpoint, config)
                .success(function (data) {
                deffered.resolve(data);
            })
                .error(function (data) {
                deffered.reject(data);
            });
            return deffered.promise;
        };
        HttpHandlerService.prototype.getCached = function (endpoint, stored) {
            var deffered = this.queryService.defer();
            if (stored) {
                deffered.resolve(stored);
                return deffered.promise;
            }
            this.httpService.get(endpoint, { cache: true })
                .success(function (data) {
                deffered.resolve(data);
            })
                .error(function (data) {
                deffered.reject(data);
            });
            return deffered.promise;
        };
        HttpHandlerService.$inject = [ngs.$http, ngs.$q];
        return HttpHandlerService;
    })(Service);
    App.HttpHandlerService = HttpHandlerService;
})(App || (App = {}));

/// <reference path="../../typings/appinsights.d.ts" />
/// <reference path="../../../common/service.ts" />
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Service = Common.Service;
    var PageTracker = (function (_super) {
        __extends(PageTracker, _super);
        function PageTracker() {
            _super.call(this);
        }
        PageTracker.prototype.trackPage = function (pagePath, pageTitle) {
            if (window.ga) {
                window.ga("send", "pageview", { "page": pagePath, "title": pageTitle });
            }
            if (window.appInsights) {
                window.appInsights.trackPageView(pageTitle, pagePath);
            }
        };
        return PageTracker;
    })(Service);
    App.PageTracker = PageTracker;
})(App || (App = {}));

"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Service = Common.Service;
    var Services = App.Settings.Services;
    var AccountService = (function (_super) {
        __extends(AccountService, _super);
        function AccountService($http) {
            _super.call(this);
            this.httpService = $http;
        }
        AccountService.prototype.validateToken = function (token) {
            return this.httpService.post("/api/token", "\"" + token + "\"");
        };
        AccountService.prototype.createAccount = function (user) {
            return this.httpService.post("/api/account", user);
        };
        AccountService.prototype.updateAccount = function (user) {
            return this.httpService.put("/api/account", user);
        };
        AccountService.id = "AccountService";
        AccountService.$inject = [Services.httpHandlerService];
        return AccountService;
    })(Service);
    App.AccountService = AccountService;
})(App || (App = {}));

"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Service = Common.Service;
    var ngs = Common.AngularServices;
    var ClientSettingsService = (function (_super) {
        __extends(ClientSettingsService, _super);
        function ClientSettingsService($http) {
            _super.call(this);
            this.httpService = $http;
        }
        ClientSettingsService.prototype.saveFacilityConfigurations = function (configurations) {
            return this.httpService.post(window.dashboardApiBaseUrl + "api/v1/configurations/facilities/save", {
                Configurations: configurations
            });
        };
        ClientSettingsService.prototype.getFacilityConfigurations = function () {
            return this.httpService.get(window.dashboardApiBaseUrl + "api/v1/configurations/facilities");
        };
        ClientSettingsService.$inject = [App.Settings.Services.httpHandlerService, ngs.$sessionStorage];
        return ClientSettingsService;
    })(Service);
    App.ClientSettingsService = ClientSettingsService;
})(App || (App = {}));

"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Service = Common.Service;
    var ngs = Common.AngularServices;
    var DashboardService = (function (_super) {
        __extends(DashboardService, _super);
        function DashboardService($http, $sessionStorage) {
            _super.call(this);
            this.httpService = $http;
            this.sessionStorage = $sessionStorage;
        }
        DashboardService.prototype.get = function (endpoint, cached) {
            if (cached) {
                return this.httpService.getCached(endpoint);
            }
            else {
                return this.httpService.get(endpoint);
            }
        };
        DashboardService.prototype.getTransactions = function (clientId, facilityId, date, inactive, pageIndex, pageSize, cached) {
            var endpoint = window.transactionsApiBaseUrl + "api/v1/transactions/search/" + clientId + "/" + facilityId + "?DateFrom=" + date + "&DateTo=" + date + "&PageIndex=" + pageIndex + "&PageSize=" + pageSize + "&Inactive=" + inactive;
            return this.get(endpoint, cached);
        };
        DashboardService.prototype.getMonthlyRollingTonnages = function (clientId, facilityId, cached) {
            var endpoint = window.transactionsApiBaseUrl + "api/v1/tonnages/month/" + clientId + "/" + facilityId;
            return this.get(endpoint, cached);
        };
        DashboardService.prototype.getMonthlyRollingTonnagesVsRevenue = function (clientId, facilityId, cached) {
            var endpoint = window.transactionsApiBaseUrl + "api/v1/tonnages/rolling/vs/revenue/" + clientId + "/" + facilityId;
            return this.get(endpoint, cached);
        };
        DashboardService.prototype.getMonthlyRollingRevenue = function (clientId, facilityId, cached) {
            var endpoint = window.transactionsApiBaseUrl + "api/v1/revenue/month/" + clientId + "/" + facilityId;
            return this.get(endpoint, cached);
        };
        DashboardService.prototype.getMonthlyRollingTransactionsCount = function (clientId, facilityId, cached) {
            var endpoint = window.transactionsApiBaseUrl + "api/v1/transactions-count/month/" + clientId + "/" + facilityId;
            return this.get(endpoint, cached);
        };
        DashboardService.prototype.getAverageProcessingTime = function (clientId, facilityId, cached) {
            var endpoint = window.transactionsApiBaseUrl + "api/v1/processing-time/month/" + clientId + "/" + facilityId;
            return this.get(endpoint, cached);
        };
        DashboardService.prototype.getCancelledChangedTicketStatistics = function (clientId, facilityId, cached) {
            var endpoint = window.transactionsApiBaseUrl + "api/v1/statistics/week/" + clientId + "/" + facilityId;
            return this.get(endpoint, cached);
        };
        DashboardService.prototype.getTicketStatisticsByWeek = function (clientId, facilityId, cached) {
            var endpoint = window.transactionsApiBaseUrl + "api/v1/weekly-statistics/6month/" + clientId + "/" + facilityId;
            return this.get(endpoint, cached);
        };
        DashboardService.prototype.getTicketStatisticsByDayOfWeek = function (clientId, facilityId, cached) {
            var endpoint = window.transactionsApiBaseUrl + "api/v1/dayofweek-statistics/6month/" + clientId + "/" + facilityId;
            return this.get(endpoint, cached);
        };
        DashboardService.prototype.getTopProducts = function (clientId, facilityId, cached) {
            var endpoint = window.transactionsApiBaseUrl + "api/v1/top/products/revenue/month/" + clientId + "/" + facilityId;
            return this.get(endpoint, cached);
        };
        DashboardService.prototype.getTopCustomers = function (clientId, facilityId, cached) {
            var endpoint = window.transactionsApiBaseUrl + "api/v1/top/customers/revenue/month/" + clientId + "/" + facilityId;
            return this.get(endpoint, cached);
        };
        DashboardService.prototype.getTicketStatisticsByHourOfDay = function (clientId, facilityId, dayOfWeek, cached) {
            var endpoint = "";
            if (dayOfWeek) {
                endpoint = window.transactionsApiBaseUrl + "api/v1/hourofday-statistics/6month/" + clientId + "/" + facilityId + "?DayOfWeek=" + dayOfWeek;
            }
            else {
                endpoint = window.transactionsApiBaseUrl + "api/v1/hourofday-statistics/6month/" + clientId + "/" + facilityId;
            }
            return this.get(endpoint, cached);
        };
        DashboardService.prototype.getRevenueStatisticsByHourOfDay = function (clientId, facilityId, date, cached) {
            var endpoint = window.transactionsApiBaseUrl + "api/v1/revenuehourofday-statistics/month/" + clientId + "/" + facilityId + "/?DayOfWeek=" + encodeURIComponent(date);
            return this.get(endpoint, cached);
        };
        DashboardService.prototype.getTonnagesVsRevenueDailyDetails = function (clientId, facilityId, date, cached) {
            var endpoint = window.transactionsApiBaseUrl + "api/v1/tonnages/vs/revenue/details/" + clientId + "/" + facilityId + "/?DayOfWeek=" + encodeURIComponent(date);
            return this.get(endpoint, cached);
        };
        DashboardService.prototype.getDynamicData = function (endpoint, cached) {
            return this.get(endpoint, cached);
        };
        DashboardService.prototype.getInboundMonthlyRollingTonnages = function (clientId, facilityId, cached) {
            var endpoint = window.transactionsApiBaseUrl + "api/v1/inbound-tonnages/month/" + clientId + "/" + facilityId;
            return this.get(endpoint, cached);
        };
        DashboardService.prototype.getOutboundMonthlyRollingTonnages = function (clientId, facilityId, cached) {
            var endpoint = window.transactionsApiBaseUrl + "api/v1/outbound-tonnages/month/" + clientId + "/" + facilityId;
            return this.get(endpoint, cached);
        };
        DashboardService.$inject = [App.Settings.Services.httpHandlerService, ngs.$sessionStorage];
        return DashboardService;
    })(Service);
    App.DashboardService = DashboardService;
})(App || (App = {}));

"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Service = Common.Service;
    var LocationService = (function (_super) {
        __extends(LocationService, _super);
        function LocationService($http) {
            _super.call(this);
            this.httpService = $http;
        }
        LocationService.prototype.getLocation = function (filter) {
            return this.httpService.getCached("/api/countries?filter=" + filter);
        };
        LocationService.prototype.getStates = function (countryCode) {
            return this.httpService.getCached("/api/states/" + countryCode);
        };
        LocationService.$inject = [App.Settings.Services.httpHandlerService];
        return LocationService;
    })(Service);
    App.LocationService = LocationService;
})(App || (App = {}));

"use strict";
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Service = Common.Service;
    var ngs = Common.AngularServices;
    var NotificationService = (function (_super) {
        __extends(NotificationService, _super);
        function NotificationService($rootScope) {
            _super.call(this);
            var that = this;
            this.rootScope = $rootScope;
            //this.connection = $.hubConnection();
            //this.proxy = this.connection.createHubProxy("NotificationsHub");
            //this.proxy.on("notify", notifications => {
            //    that.rootScope.$broadcast("notifications", notifications);
            //});
            //this.connection.start();
        }
        NotificationService.$inject = [ngs.$rootScope];
        return NotificationService;
    })(Service);
    App.NotificationService = NotificationService;
})(App || (App = {}));

"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Service = Common.Service;
    var ResourceService = (function (_super) {
        __extends(ResourceService, _super);
        function ResourceService($http) {
            _super.call(this);
            this.httpService = $http;
        }
        ResourceService.prototype.getUserinfo = function (resourceUri) {
            return this.httpService.get(resourceUri);
        };
        ResourceService.$inject = [App.Settings.Services.httpHandlerService];
        return ResourceService;
    })(Service);
    App.ResourceService = ResourceService;
})(App || (App = {}));

"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Service = Common.Service;
    var ngs = Common.AngularServices;
    var SiteService = (function (_super) {
        __extends(SiteService, _super);
        function SiteService($http, $sessionStorage) {
            _super.call(this);
            this.httpService = $http;
            this.sessionStorage = $sessionStorage;
        }
        SiteService.prototype.getSites = function (clientId) {
            return this.httpService.get(window.transactionsApiBaseUrl + "api/v1/sites/" + clientId);
        };
        SiteService.prototype.getSiteLocations = function (clientId) {
            return this.httpService.get(window.transactionsApiBaseUrl + "api/v1/sites/" + clientId + "/sites/locations");
        };
        SiteService.prototype.setFacilities = function (clientId, facilities) {
            var request = {
                ClientId: clientId,
                Facilities: []
            };
            angular.forEach(facilities, function (facility) {
                request.Facilities.push({
                    SiteId: facility.SiteId,
                    LocationId: facility.LocationId,
                    FacilityType: facility.FacilityType
                });
            });
            return this.httpService.post(window.transactionsApiBaseUrl + "api/v1/facilities", request);
        };
        SiteService.$inject = [App.Settings.Services.httpHandlerService, ngs.$sessionStorage];
        return SiteService;
    })(Service);
    App.SiteService = SiteService;
})(App || (App = {}));

"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Service = Common.Service;
    var ngs = Common.AngularServices;
    var UserSettingsService = (function (_super) {
        __extends(UserSettingsService, _super);
        function UserSettingsService($http, $sessionStorage) {
            _super.call(this);
            this.httpService = $http;
            this.sessionStorage = $sessionStorage;
        }
        UserSettingsService.prototype.getUserWorkspaces = function () {
            return this.httpService.get(window.dashboardApiBaseUrl + "api/v1/workspace/all");
        };
        UserSettingsService.prototype.getLastViewedWorkspace = function () {
            return this.httpService.get(window.dashboardApiBaseUrl + "api/v1/preferences/workspaces/last/details");
        };
        UserSettingsService.prototype.canPublish = function () {
            return this.httpService.get(window.dashboardApiBaseUrl + "api/v1/preferences/workspaces/can-publish");
        };
        UserSettingsService.prototype.saveLastViewedWorkspace = function (wokspaceId) {
            return this.httpService.post(window.dashboardApiBaseUrl + "api/v1/preferences/workspaces/last/save", {
                "WorkspaceId": wokspaceId
            });
        };
        UserSettingsService.$inject = [App.Settings.Services.httpHandlerService, ngs.$sessionStorage];
        return UserSettingsService;
    })(Service);
    App.UserSettingsService = UserSettingsService;
})(App || (App = {}));

"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Service = Common.Service;
    var ngs = Common.AngularServices;
    var WorkspaceService = (function (_super) {
        __extends(WorkspaceService, _super);
        function WorkspaceService($http) {
            _super.call(this);
            this.httpService = $http;
        }
        WorkspaceService.prototype.geWorkspaceTypes = function () {
            return this.httpService.get(window.dashboardApiBaseUrl + "api/v1/workspace/types");
        };
        WorkspaceService.prototype.geWorkspaceTypeWidgets = function (workspaceType) {
            return this.httpService.get(window.dashboardApiBaseUrl + "api/v1/workspace/type/widgets?WorkspaceType=" + workspaceType);
        };
        WorkspaceService.prototype.geAvailableSisenseWidgets = function (workspaceType) {
            return this.httpService.get(window.dashboardApiBaseUrl + "api/v1/sisense/dashboards/widgets/available?WorkspaceType=" + workspaceType);
        };
        WorkspaceService.prototype.saveWidgetDetails = function (widgetDetails, workspaceType) {
            var data = {
                WidgetId: widgetDetails.Id,
                X: widgetDetails.X,
                Y: widgetDetails.Y,
                Width: widgetDetails.Width,
                Height: widgetDetails.Height,
                Title: widgetDetails.Title,
                Url: widgetDetails.DataSourceUrl,
                Id: widgetDetails.ExternalId,
                Type: widgetDetails.Type,
                Style: widgetDetails.Style,
                IsSisense: widgetDetails.DataSourceType === App.DataSourceType.SisenseCsWarehouse
            };
            return this.httpService.post(window.dashboardApiBaseUrl + "api/v1/workspace/widgets/update", data);
        };
        WorkspaceService.prototype.publishSisenseWidget = function (widgetDetails, workspaceType) {
            var data = {
                X: widgetDetails.X,
                Y: widgetDetails.Y,
                Width: widgetDetails.Width,
                Height: widgetDetails.Height,
                Title: widgetDetails.Title,
                Url: widgetDetails.DataSourceUrl,
                Id: widgetDetails.ExternalId,
                WorkspaceType: workspaceType
            };
            return this.httpService.post(window.dashboardApiBaseUrl + "api/v1/workspace/widgets/publish", data);
        };
        WorkspaceService.prototype.unPublishWidget = function (widgetId, workspaceType) {
            return this.httpService.post(window.dashboardApiBaseUrl + "api/v1/workspace/widgets/unpublish", { WidgetId: widgetId, WorkspaceType: workspaceType });
        };
        WorkspaceService.$inject = [App.Settings.Services.httpHandlerService, ngs.$sessionStorage];
        return WorkspaceService;
    })(Service);
    App.WorkspaceService = WorkspaceService;
})(App || (App = {}));

/// <reference path="../../../tools/typings/tsd.d.ts" />
/// <reference path="../../../common/service.ts" />
/// <reference path="../../typings/ngstorage.d.ts" />
/// <reference path="../../typings/oauth.d.ts" />
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Service = Common.Service;
    var ngs = Common.AngularServices;
    var oauths = Common.OAuthServices;
    var AuthenticationService = (function (_super) {
        __extends(AuthenticationService, _super);
        function AuthenticationService($rootScope, $sessionStorage, $timeout, $accessToken, $endpoint, $accountService, $resourceService, $http, $window, $location) {
            var _this = this;
            _super.call(this);
            this.rootScope = $rootScope;
            this.location = $location;
            this.sessionStorage = $sessionStorage;
            this.timeout = $timeout;
            this.accessToken = $accessToken;
            this.endpoint = $endpoint;
            this.accountService = $accountService;
            this.resourceService = $resourceService;
            this.window = $window;
            this.httpService = $http;
            this.rootScope.$on("oauth:expired", function () {
                console.log("token has expired");
                _this.accessToken.destroy();
                $sessionStorage.currentUser = null;
                window.location.href = "/";
                return;
            });
        }
        AuthenticationService.prototype.setCurrentUser = function (user) {
            this.sessionStorage.currentUser = user;
            this.sessionStorage.lastloginDate = new Date();
            console.log("'" + user.Email + "' has logged in");
            if (window.useRaygun) {
                Raygun.setUser(user.Email);
            }
            if (ga && user.NausDetails) {
                ga("set", "&uid", user.NausDetails.IdComponent);
            }
            this.rootScope.$broadcast(App.Settings.Events.userRetrieved, user);
        };
        AuthenticationService.prototype.getCurrentUser = function () {
            return this.sessionStorage.currentUser;
        };
        AuthenticationService.prototype.getClients = function () {
            return this.sessionStorage.clients;
        };
        AuthenticationService.prototype.getLastLoginDate = function () {
            return this.sessionStorage.lastloginDate;
        };
        AuthenticationService.prototype.getToken = function () {
            var tokenData = this.accessToken.get();
            return tokenData ? tokenData.access_token : "";
        };
        AuthenticationService.prototype.getExpiryDate = function () {
            var tokenData = this.accessToken.get();
            return tokenData ? new Date(this.accessToken.get().expires_at) : null;
        };
        AuthenticationService.prototype.isExpired = function () {
            var tokenData = this.accessToken.get();
            return tokenData ? new Date(this.accessToken.get().expires_at) < new Date() : true;
        };
        AuthenticationService.prototype.isLoggedin = function () {
            return this.sessionStorage.currentUser &&
                this.accessToken.get() &&
                this.rootScope.token;
        };
        AuthenticationService.prototype.login = function () {
            this.rootScope.token = this.accessToken.get();
            if (!this.rootScope.token) {
                this.endpoint.redirect();
                return;
            }
            if (!(this.sessionStorage.currentUser)) {
                this.checkClientAccess();
                this.loadUserDetails();
            }
            else {
                this.checkClientAccess();
            }
        };
        AuthenticationService.prototype.checkClientAccess = function () {
            var _this = this;
            this.rootScope.$broadcast(App.Settings.Events.clientsRetrieving);
            var that = this;
            that.getAccessibleClients().then(function (data) {
                if (!data || !data.Clients || data.Clients.length === 0) {
                    _this.rootScope.$broadcast(App.Settings.Events.unauthorizedAccessDetected);
                    that.location.path("/unauthorized");
                }
                else {
                    that.sessionStorage.clients = data.Clients;
                    _this.rootScope.$broadcast(App.Settings.Events.clientsRetrieved, data.Clients);
                }
            }, function (data) {
                _this.rootScope.$broadcast(App.Settings.Events.unauthorizedAccessDetected);
                that.location.path("/unauthorized");
            });
        };
        AuthenticationService.prototype.logout = function (scope) {
            var _this = this;
            this.timeout(function () {
                if (window.useRaygun) {
                    Raygun.setUser("anonymous");
                }
                _this.accessToken.destroy(scope);
                _this.sessionStorage.currentUser = null;
                _this.sessionStorage.lastloginDate = null;
                _this.sessionStorage.currency = null;
                _this.sessionStorage.trialDirectory = null;
                _this.rootScope.$broadcast("oauth:logout");
                var oauthUrl = window.authorizeUri;
                var cacheBuster = (new Date()).getTime();
                var backUrl = encodeURIComponent(window.location.origin + "/dashboard");
                var logoutUrl = oauthUrl + "/account/logout?backUrl=" + backUrl + "&nocache=" + cacheBuster;
                window.location = logoutUrl;
            }, 1000);
        };
        AuthenticationService.prototype.relogin = function (scope) {
            var _this = this;
            this.timeout(function () {
                _this.accessToken.destroy(scope);
                _this.sessionStorage.currentUser = null;
                _this.sessionStorage.lastloginDate = null;
                _this.endpoint.redirect();
            }, 10);
        };
        AuthenticationService.prototype.loadUserDetails = function () {
            var _this = this;
            var that = this;
            this.resourceService.getUserinfo(window.resourceUri).then(function (data) {
                that.setCurrentUser(data);
            }, function (data, status) {
                if (status && (status === "401" || status === "403" || status === 401 || status === 403)) {
                    _this.accessToken.destroy();
                    _this.sessionStorage.currentUser = null;
                    _this.sessionStorage.lastloginDate = null;
                    _this.endpoint.redirect();
                    return;
                }
                console.log(data);
            });
        };
        AuthenticationService.prototype.getAccessibleClients = function () {
            return this.httpService.getCached(window.transactionsApiBaseUrl + "api/v1/auth/client/details");
        };
        AuthenticationService.$inject = [ngs.$rootScope, ngs.$sessionStorage, ngs.$timeout, oauths.accessToken, oauths.endpoint, App.Settings.Services.accountService, App.Settings.Services.resourceService, App.Settings.Services.httpHandlerService, ngs.$window, ngs.$location];
        return AuthenticationService;
    })(Service);
    App.AuthenticationService = AuthenticationService;
})(App || (App = {}));

"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Service = Common.Service;
    var ngs = Common.AngularServices;
    var PingService = (function (_super) {
        __extends(PingService, _super);
        function PingService($http, $authService) {
            _super.call(this);
            this.httpService = $http;
            this.authService = $authService;
        }
        PingService.prototype.ping = function () {
            var that = this;
            this.httpService.get("/api/ping")
                .success(function () { })
                .error(function (reason, status) {
                if (status === 401 || status === 403) {
                    that.authService.logout(null);
                }
            });
        };
        PingService.$inject = [ngs.$http, App.Settings.Services.authenticationService];
        return PingService;
    })(Service);
    App.PingService = PingService;
})(App || (App = {}));

"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Service = Common.Service;
    var ngs = Common.AngularServices;
    var DundasService = (function (_super) {
        __extends(DundasService, _super);
        function DundasService($http, $sessionStorage) {
            _super.call(this);
            this.httpService = $http;
            this.sessionStorage = $sessionStorage;
        }
        DundasService.prototype.authenticate = function () {
            var that = this;
            return that.httpService.get(window.dashboardApiBaseUrl + "api/v1/dundas/security/logon/token");
        };
        DundasService.$inject = [App.Settings.Services.httpHandlerService, ngs.$sessionStorage];
        return DundasService;
    })(Service);
    App.DundasService = DundasService;
})(App || (App = {}));

"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Service = Common.Service;
    var ngs = Common.AngularServices;
    var WidgetFactory = (function (_super) {
        __extends(WidgetFactory, _super);
        function WidgetFactory($dashboardService, $dundasService, $sce, $timeout) {
            _super.call(this);
            this.dashboardService = $dashboardService;
            this.dundasService = $dundasService;
            this.sce = $sce;
            this.timeoutService = $timeout;
        }
        WidgetFactory.prototype.getWidgeModel = function (widgetDetails) {
            var that = this;
            var chartConfig = this.getChartConfig(widgetDetails);
            var widgetModel = {
                id: widgetDetails.Id,
                currentChartIndex: 0,
                layout: {
                    sizeX: widgetDetails.Width,
                    sizeY: widgetDetails.Height,
                    row: widgetDetails.X - 1,
                    col: widgetDetails.Y - 1
                },
                mainChart: {
                    chart: this.getChart(widgetDetails, chartConfig),
                    title: widgetDetails.Title,
                    loading: false,
                    type: widgetDetails.Type,
                    style: widgetDetails.Style,
                    seriesClick: function (chart, selectedItems, facilityDetails) {
                        var item = chart.dataRows[selectedItems[0].row].c[0];
                        console.log("Selected: " + item.v + " for dataset " + selectedItems[0].column);
                        that.loadDetailsChart(widgetModel, widgetDetails, chart, selectedItems, facilityDetails, true);
                    },
                    widgetLogoClass: this.getIconByWidgetStyle(widgetDetails.Style),
                    noData: false,
                    loadData: function (facilityDetails, showLoadingIndicator, cached) {
                        that.loadDataByType(widgetDetails, widgetModel, facilityDetails, showLoadingIndicator, cached);
                    }
                },
                dataSourceType: widgetDetails.DataSourceType,
                dataSourceUrl: widgetDetails.DataSourceUrl,
                widgetExternalRenderUrl: null
            };
            that.configureDetailsChart(widgetDetails, widgetModel);
            return widgetModel;
        };
        WidgetFactory.prototype.getIconByWidgetStyle = function (widgetStyle) {
            switch (widgetStyle) {
                case App.WidgetStyle.ColumnChart:
                case App.WidgetStyle.BarChart:
                    return "fa-bar-chart";
                case App.WidgetStyle.PieChart:
                    return "fa-pie-chart";
                case App.WidgetStyle.AreaChart:
                case App.WidgetStyle.LineChart:
                    return "fa-line-chart";
                case App.WidgetStyle.Table:
                    return "fa-list";
                case App.WidgetStyle.Number:
                    return "fa-tachometer";
                default:
                    return "fa-list";
            }
        };
        WidgetFactory.prototype.getChartConfig = function (widgetDetails) {
            var config = {
                title: "",
                column1Title: "Value 1",
                column2Title: "Value 2",
                hAxisTitle: "",
                vAxisTitle: "",
                numberFormat: "#,##0.00",
                chartType: App.WidgetStyle[widgetDetails.Style]
            };
            switch (widgetDetails.Type) {
                case App.WidgetType.Rolling30DaysTonnagesVsSamePeriodLastYear:
                    config.column1Title = "Last Year Tonnages";
                    config.column2Title = "Current Year Tonnages";
                    break;
                case App.WidgetType.AverageTransactionProcessingTime:
                case App.WidgetType.NumberOfOperatorErrors:
                case App.WidgetType.TotalRollingRevenue:
                case App.WidgetType.TotalRollingTonnage:
                    config.column1Title = "";
                    config.column2Title = "";
                    break;
                case App.WidgetType.Rolling30DaysRevenueVsSamePeriodLastYear:
                    config.column1Title = "Last Year Revenue";
                    config.column2Title = "Current Year Revenue";
                    config.numberFormat = "$ #,##0.00";
                    break;
                case App.WidgetType.Rolling30DaysTransactionCountsVsSamePeriodLastYear:
                    config.column1Title = "Last Year Transactions Count";
                    config.column2Title = "Current Year Transactions Count";
                    break;
                case App.WidgetType.Rolling7DaysCancelledAndAmendedTransactions:
                    config.column1Title = "Cancelled Tickets";
                    config.column2Title = "Changed Tickets";
                    config.chartType = App.WidgetStyle[App.WidgetStyle.ColumnChart];
                    config.colors = App.Palettes.cancelledPalette;
                    config.isStacked = true;
                    config.numberFormat = "#,##0";
                    break;
                case App.WidgetType.Rolling6MonthsWeeklyTransactionCount:
                    config.column1Title = "Tickets";
                    config.numberFormat = "#,##0";
                    break;
                case App.WidgetType.Rolling6MonthsAvgWeekdayTransactionCount:
                    config.column1Title = "Tickets";
                    config.numberFormat = "#,##0.00";
                    break;
                case App.WidgetType.Rolling6MonthsAvgHoulyTransactionCount:
                    config.column1Title = "Tickets";
                    config.numberFormat = "#,##0.00";
                    break;
                case App.WidgetType.TopTenCustomersByRevenue:
                    config.column1Title = "Customers";
                    config.numberFormat = "#,##0";
                    config.legendSetting = { position: "left" };
                    config.colors = App.Palettes.darkerPalette;
                    break;
                case App.WidgetType.TopTenProductsByRevenue:
                    config.column1Title = "Products";
                    config.numberFormat = "#,##0";
                    config.legendSetting = { position: "left" };
                    config.colors = App.Palettes.darkerPalette;
                    break;
                case App.WidgetType.Daily30DaysRevenueDetails:
                    config.column1Title = "Customer";
                    config.column2Title = "Product";
                    config.chartType = App.WidgetStyle[App.WidgetStyle.Table];
                    config.isStacked = true;
                    config.numberFormat = "#,##0";
                    break;
                case App.WidgetType.Daily30DaysTonnagesVsRevenueDetails:
                    config.column1Title = "Customer";
                    config.column2Title = "Product";
                    config.chartType = App.WidgetStyle[App.WidgetStyle.Table];
                    config.isStacked = true;
                    config.numberFormat = "#,##0";
                    break;
                case App.WidgetType.Rolling30DaysInboundTonnagesVsSamePeriodLastYear:
                    config.column1Title = "Last Year Inbound Tonnages";
                    config.column2Title = "Current Year Inbound Tonnages";
                    break;
                case App.WidgetType.Rolling30DaysOutboundTonnagesVsSamePeriodLastYear:
                    config.column1Title = "Last Year Outbound Tonnages";
                    config.column2Title = "Current Year Outbound Tonnages";
                    break;
                case App.WidgetType.Rolling30DaysTonnagesVsRevenue:
                    config.column1Title = "Tonnages";
                    config.column2Title = "Revenue";
                    break;
            }
            return config;
        };
        WidgetFactory.prototype.getChart = function (widgetDetails, chartConfig) {
            switch (widgetDetails.Type) {
                case App.WidgetType.Rolling6MonthsWeeklyTransactionCount:
                case App.WidgetType.Rolling6MonthsAvgWeekdayTransactionCount:
                case App.WidgetType.Rolling6MonthsAvgHoulyTransactionCount:
                case App.WidgetType.TopTenProductsByRevenue:
                case App.WidgetType.TopTenCustomersByRevenue:
                    return new App.OneSeriesChartObject(chartConfig);
                case App.WidgetType.Daily30DaysRevenueDetails:
                    return new App.Daily30DaysRevenueDetailsTableObject();
                case App.WidgetType.Daily30DaysTonnagesVsRevenueDetails:
                    return new App.DailyTickedDetailsTableObject();
                case App.WidgetType.Rolling30DaysInboundTonnagesVsSamePeriodLastYear:
                case App.WidgetType.Rolling30DaysTonnagesVsRevenue:
                case App.WidgetType.Rolling30DaysOutboundTonnagesVsSamePeriodLastYear:
                default:
                    return new App.TwoSeriesChartObject(chartConfig);
            }
        };
        WidgetFactory.prototype.loadDetailsChart = function (widgetModel, widgetDetails, chart, selectedItems, facilityDetails, cached) {
            var record = chart.dataRows[selectedItems[0].row];
            if (widgetDetails.Type === App.WidgetType.Rolling7DaysCancelledAndAmendedTransactions) {
                widgetModel.currentChartIndex = 1;
                widgetModel.detailedChart.title = "Cancelled and Changed Ticket Details for " + record.label;
                widgetModel.detailedChart.loadDetailsData(facilityDetails, record.id, cached);
            }
            else if (widgetDetails.Type === App.WidgetType.Rolling6MonthsAvgWeekdayTransactionCount) {
                widgetModel.currentChartIndex = 1;
                widgetModel.detailedChart.title = "Average transactions per hour of day for " + record.label + "s in last six months";
                widgetModel.detailedChart.loadDetailsData(facilityDetails, record.id, cached);
            }
            else if (widgetDetails.Type === App.WidgetType.Rolling30DaysRevenueVsSamePeriodLastYear) {
                widgetModel.currentChartIndex = 1;
                widgetModel.detailedChart.title = "Revenue Details";
                widgetModel.detailedChart.loadDetailsData(facilityDetails, record.id, cached);
            }
            else if (widgetDetails.Type === App.WidgetType.Rolling30DaysTonnagesVsRevenue) {
                widgetModel.currentChartIndex = 1;
                widgetModel.detailedChart.title = "Tonnages vs Revenue Details";
                widgetModel.detailedChart.loadDetailsData(facilityDetails, record.id, cached);
            }
        };
        WidgetFactory.prototype.configureDetailsChart = function (widgetDetails, widgetModel) {
            var that = this;
            if (widgetDetails.Type === App.WidgetType.Rolling7DaysCancelledAndAmendedTransactions) {
                widgetModel.detailedChart = {
                    chart: new App.CancelledChangedTransactionsTableObject(),
                    title: widgetDetails.Title,
                    loading: false,
                    type: widgetDetails.Type,
                    style: widgetDetails.Style,
                    seriesClick: function (chart, selectedItems) {
                        var item = chart.dataRows[selectedItems[0].row].c[0];
                        console.log("Selected: " + item.v + " for dataset " + selectedItems[0].column);
                    },
                    widgetLogoClass: this.getIconByWidgetStyle(widgetDetails.Style),
                    noData: false,
                    backButtonClick: function () {
                        widgetModel.currentChartIndex = 0;
                    },
                    loadData: function () {
                    },
                    loadDetailsData: function (facility, selectedId, cached) {
                        var thatChart = this;
                        thatChart.loading = true;
                        that.dashboardService.getTransactions(facility.ClientId, facility.SiteId, selectedId, true, null, null, cached).then(function (data) {
                            thatChart.chart.load(data.Transactions);
                            thatChart.loading = false;
                            that.timeoutService(function () {
                                jQuery(".reason-view").tooltip();
                            }, 500);
                        }, function (data) {
                            console.log("Error loading data: " + data);
                            thatChart.loading = false;
                        });
                    }
                };
            }
            else if (widgetDetails.Type === App.WidgetType.Rolling6MonthsAvgWeekdayTransactionCount) {
                var childDetails = {
                    Id: widgetDetails.Id,
                    Title: widgetDetails.Title,
                    Style: widgetDetails.Style,
                    Type: App.WidgetType.Rolling6MonthsAvgHoulyTransactionCount,
                    X: widgetDetails.X,
                    Y: widgetDetails.Y,
                    Width: widgetDetails.Width,
                    Height: widgetDetails.Height,
                    DataSourceType: widgetDetails.DataSourceType,
                    DataSourceUrl: widgetDetails.DataSourceUrl,
                    ExternalId: widgetDetails.ExternalId
                };
                widgetModel.detailedChart = {
                    chart: this.getChart(childDetails, this.getChartConfig(widgetDetails)),
                    title: widgetDetails.Title,
                    loading: false,
                    type: widgetDetails.Type,
                    style: widgetDetails.Style,
                    seriesClick: function (chart, selectedItems) {
                    },
                    widgetLogoClass: this.getIconByWidgetStyle(widgetDetails.Style),
                    noData: false,
                    backButtonClick: function () {
                        widgetModel.currentChartIndex = 0;
                    },
                    loadData: function () {
                    },
                    loadDetailsData: function (facilityDetails, selectedId, cached) {
                        var thatChart = this;
                        thatChart.loading = true;
                        that.dashboardService.getTicketStatisticsByHourOfDay(facilityDetails.ClientId, facilityDetails.SiteId, selectedId, cached).then(function (data) {
                            var anyValues = false;
                            thatChart.chart.load(Enumerable.From(data.ChartData).Select(function (d) {
                                if (d.CancelledCount !== 0 || d.ChangedCount !== 0) {
                                    anyValues = true;
                                }
                                return {
                                    date: d.Date,
                                    dateFormatted: d.DateFormatted,
                                    label: d.Label,
                                    value: d.Count
                                };
                            }));
                            thatChart.noData = !data || !data.ChartData || !anyValues;
                            thatChart.loading = false;
                        }, function (data) {
                            console.log("Error loading data: " + data);
                            thatChart.noData = true;
                            thatChart.loading = false;
                        });
                    }
                };
            }
            else if (widgetDetails.Type === App.WidgetType.Rolling30DaysRevenueVsSamePeriodLastYear) {
                var childDetails = {
                    Id: widgetDetails.Id,
                    Title: widgetDetails.Title,
                    Style: widgetDetails.Style,
                    Type: App.WidgetType.Daily30DaysRevenueDetails,
                    X: widgetDetails.X,
                    Y: widgetDetails.Y,
                    Width: widgetDetails.Width,
                    Height: widgetDetails.Height,
                    DataSourceType: widgetDetails.DataSourceType,
                    DataSourceUrl: widgetDetails.DataSourceUrl,
                    ExternalId: widgetDetails.ExternalId
                };
                widgetModel.detailedChart = {
                    chart: this.getChart(childDetails, this.getChartConfig(widgetDetails)),
                    title: widgetDetails.Title,
                    loading: false,
                    type: widgetDetails.Type,
                    style: widgetDetails.Style,
                    seriesClick: function (chart, selectedItems) {
                    },
                    widgetLogoClass: this.getIconByWidgetStyle(widgetDetails.Style),
                    noData: false,
                    backButtonClick: function () {
                        widgetModel.currentChartIndex = 0;
                    },
                    loadData: function () {
                    },
                    loadDetailsData: function (facilityDetails, selectedId, cached) {
                        var thatChart = this;
                        thatChart.loading = true;
                        that.dashboardService.getRevenueStatisticsByHourOfDay(facilityDetails.ClientId, facilityDetails.SiteId, selectedId, cached).then(function (data) {
                            thatChart.chart.load(data.ChartData);
                            thatChart.noData = !data || !data.ChartData || data.ChartData.length === 0;
                            thatChart.loading = false;
                        }, function (data) {
                            console.log("Error loading data: " + data);
                            thatChart.loading = false;
                        });
                    }
                };
            }
            else if (widgetDetails.Type === App.WidgetType.Rolling30DaysTonnagesVsRevenue) {
                var childDetails = {
                    Id: widgetDetails.Id,
                    Title: widgetDetails.Title,
                    Style: widgetDetails.Style,
                    Type: App.WidgetType.Daily30DaysTonnagesVsRevenueDetails,
                    X: widgetDetails.X,
                    Y: widgetDetails.Y,
                    Width: widgetDetails.Width,
                    Height: widgetDetails.Height,
                    DataSourceType: widgetDetails.DataSourceType,
                    DataSourceUrl: widgetDetails.DataSourceUrl,
                    ExternalId: widgetDetails.ExternalId
                };
                widgetModel.detailedChart = {
                    chart: this.getChart(childDetails, this.getChartConfig(widgetDetails)),
                    title: widgetDetails.Title,
                    loading: false,
                    type: widgetDetails.Type,
                    style: widgetDetails.Style,
                    seriesClick: function (chart, selectedItems) {
                    },
                    widgetLogoClass: this.getIconByWidgetStyle(widgetDetails.Style),
                    noData: false,
                    backButtonClick: function () {
                        widgetModel.currentChartIndex = 0;
                    },
                    loadData: function () {
                    },
                    loadDetailsData: function (facilityDetails, selectedId, cached) {
                        var thatChart = this;
                        thatChart.loading = true;
                        that.dashboardService.getTonnagesVsRevenueDailyDetails(facilityDetails.ClientId, facilityDetails.SiteId, selectedId, cached).then(function (data) {
                            thatChart.chart.load(data.ChartData);
                            thatChart.noData = !data || !data.ChartData || data.ChartData.length === 0;
                            thatChart.loading = false;
                        }, function (data) {
                            console.log("Error loading data: " + data);
                            thatChart.loading = false;
                        });
                    }
                };
            }
        };
        WidgetFactory.prototype.loadDataByType = function (widgeDetails, widgetModel, facilityDetails, showLoadingIndicator, cached) {
            var that = this;
            widgetModel.mainChart.loading = showLoadingIndicator;
            if (widgeDetails.DataSourceType === App.DataSourceType.MandalayCsWarehouse) {
                switch (widgeDetails.Type) {
                    case App.WidgetType.Rolling30DaysTonnagesVsSamePeriodLastYear:
                        that.dashboardService.getMonthlyRollingTonnages(facilityDetails.ClientId, facilityDetails.SiteId, cached).then(function (data) {
                            var anyValues = false;
                            widgetModel.mainChart.chart.load(Enumerable.From(data.ChartData).Select(function (d) {
                                if (d.PreviousYearValue !== 0 || d.CurrentYearValue !== 0) {
                                    anyValues = true;
                                }
                                return {
                                    label: d.Label,
                                    firstValue: d.PreviousYearValue,
                                    secondValue: d.CurrentYearValue
                                };
                            }));
                            widgetModel.mainChart.noData = !data || !data.ChartData || !anyValues;
                            widgetModel.mainChart.loading = false;
                        }, function (data) {
                            console.log("Error loading data: " + data);
                            widgetModel.mainChart.noData = true;
                            widgetModel.mainChart.loading = false;
                        });
                        break;
                    case App.WidgetType.Rolling30DaysTonnagesVsRevenue:
                        that.dashboardService.getMonthlyRollingTonnagesVsRevenue(facilityDetails.ClientId, facilityDetails.SiteId, cached).then(function (data) {
                            var anyValues = false;
                            widgetModel.mainChart.chart.load(Enumerable.From(data.ChartData).Select(function (d) {
                                if (d.MeasureValue1 !== 0 || d.MeasureValue2 !== 0) {
                                    anyValues = true;
                                }
                                return {
                                    label: d.Label,
                                    firstValue: d.MeasureValue1,
                                    secondValue: d.MeasureValue2,
                                    date: d.Id
                                };
                            }));
                            widgetModel.mainChart.noData = !data || !data.ChartData || !anyValues;
                            widgetModel.mainChart.loading = false;
                        }, function (data) {
                            console.log("Error loading data: " + data);
                            widgetModel.mainChart.noData = true;
                            widgetModel.mainChart.loading = false;
                        });
                        break;
                    case App.WidgetType.AverageTransactionProcessingTime:
                        that.dashboardService.getAverageProcessingTime(facilityDetails.ClientId, facilityDetails.SiteId, cached).then(function (data) {
                            widgetModel.mainChart.chart = {
                                value: data.AvgProcessingInSeconds,
                                format: "secondsToTime"
                            };
                            widgetModel.mainChart.noData = !data || data.AvgProcessingInSeconds === 0;
                            widgetModel.mainChart.loading = false;
                        }, function (data) {
                            console.log("Error loading data: " + data);
                            widgetModel.mainChart.noData = true;
                            widgetModel.mainChart.loading = false;
                        });
                        break;
                    case App.WidgetType.Rolling30DaysRevenueVsSamePeriodLastYear:
                        that.dashboardService.getMonthlyRollingRevenue(facilityDetails.ClientId, facilityDetails.SiteId, cached).then(function (data) {
                            var anyValues = false;
                            widgetModel.mainChart.chart.load(Enumerable.From(data.ChartData).Select(function (d) {
                                if (d.PreviousYearValue !== 0 || d.CurrentYearValue !== 0) {
                                    anyValues = true;
                                }
                                return {
                                    label: d.Label,
                                    firstValue: d.PreviousYearValue,
                                    secondValue: d.CurrentYearValue,
                                    date: d.Id
                                };
                            }));
                            widgetModel.mainChart.noData = !data || !data.ChartData || !anyValues;
                            widgetModel.mainChart.loading = false;
                        }, function (data) {
                            console.log("Error loading data: " + data);
                            widgetModel.mainChart.noData = true;
                            widgetModel.mainChart.loading = false;
                        });
                        break;
                    case App.WidgetType.Rolling30DaysTransactionCountsVsSamePeriodLastYear:
                        that.dashboardService.getMonthlyRollingTransactionsCount(facilityDetails.ClientId, facilityDetails.SiteId, cached).then(function (data) {
                            var anyValues = false;
                            widgetModel.mainChart.chart.load(Enumerable.From(data.ChartData).Select(function (d) {
                                if (d.PreviousYearValue !== 0 || d.CurrentYearValue !== 0) {
                                    anyValues = true;
                                }
                                return {
                                    label: d.Label,
                                    firstValue: d.PreviousYearValue,
                                    secondValue: d.CurrentYearValue
                                };
                            }));
                            widgetModel.mainChart.noData = !data || !data.ChartData || !anyValues;
                            widgetModel.mainChart.loading = false;
                        }, function (data) {
                            console.log("Error loading data: " + data);
                            widgetModel.mainChart.noData = true;
                            widgetModel.mainChart.loading = false;
                        });
                        break;
                    case App.WidgetType.Rolling7DaysCancelledAndAmendedTransactions:
                        that.dashboardService.getCancelledChangedTicketStatistics(facilityDetails.ClientId, facilityDetails.SiteId, cached).then(function (data) {
                            var anyValues = false;
                            widgetModel.mainChart.chart.load(Enumerable.From(data.ChartData).Select(function (d) {
                                if (d.CancelledCount !== 0 || d.ChangedCount !== 0) {
                                    anyValues = true;
                                }
                                return {
                                    date: d.Date,
                                    dateFormatted: d.DateFormatted,
                                    label: d.Label,
                                    totalValue: d.Count,
                                    firstValue: d.CancelledCount,
                                    secondValue: d.ChangedCount
                                };
                            }));
                            widgetModel.mainChart.noData = !data || !data.ChartData || !anyValues;
                            widgetModel.mainChart.loading = false;
                        }, function (data) {
                            console.log("Error loading data: " + data);
                            widgetModel.mainChart.noData = true;
                            widgetModel.mainChart.loading = false;
                        });
                        break;
                    case App.WidgetType.Rolling6MonthsWeeklyTransactionCount:
                        that.dashboardService.getTicketStatisticsByWeek(facilityDetails.ClientId, facilityDetails.SiteId, cached).then(function (data) {
                            var anyValues = false;
                            widgetModel.mainChart.chart.load(Enumerable.From(data.ChartData).Select(function (d) {
                                if (d.CancelledCount !== 0 || d.ChangedCount !== 0) {
                                    anyValues = true;
                                }
                                return {
                                    date: d.Date,
                                    dateFormatted: d.DateFormatted,
                                    label: d.Label,
                                    value: d.Count
                                };
                            }));
                            widgetModel.mainChart.noData = !data || !data.ChartData || !anyValues;
                            widgetModel.mainChart.loading = false;
                        }, function (data) {
                            console.log("Error loading data: " + data);
                            widgetModel.mainChart.noData = true;
                            widgetModel.mainChart.loading = false;
                        });
                        break;
                    case App.WidgetType.Rolling6MonthsAvgWeekdayTransactionCount:
                        that.dashboardService.getTicketStatisticsByDayOfWeek(facilityDetails.ClientId, facilityDetails.SiteId, cached).then(function (data) {
                            var anyValues = false;
                            widgetModel.mainChart.chart.load(Enumerable.From(data.ChartData).Select(function (d) {
                                if (d.CancelledCount !== 0 || d.ChangedCount !== 0) {
                                    anyValues = true;
                                }
                                return {
                                    date: d.Date,
                                    dateFormatted: d.DateFormatted,
                                    label: d.Label,
                                    value: d.Count
                                };
                            }));
                            widgetModel.mainChart.noData = !data || !data.ChartData || !anyValues;
                            widgetModel.mainChart.loading = false;
                        }, function (data) {
                            console.log("Error loading data: " + data);
                            widgetModel.mainChart.noData = true;
                            widgetModel.mainChart.loading = false;
                        });
                        break;
                    case App.WidgetType.Rolling6MonthsAvgHoulyTransactionCount:
                        that.dashboardService.getTicketStatisticsByHourOfDay(facilityDetails.ClientId, facilityDetails.SiteId, null, cached).then(function (data) {
                            var anyValues = false;
                            widgetModel.mainChart.chart.load(Enumerable.From(data.ChartData).Select(function (d) {
                                if (d.CancelledCount !== 0 || d.ChangedCount !== 0) {
                                    anyValues = true;
                                }
                                return {
                                    date: d.Date,
                                    dateFormatted: d.DateFormatted,
                                    label: d.Label,
                                    value: d.Count
                                };
                            }));
                            widgetModel.mainChart.noData = !data || !data.ChartData || !anyValues;
                            widgetModel.mainChart.loading = false;
                        }, function (data) {
                            console.log("Error loading data: " + data);
                            widgetModel.mainChart.noData = true;
                            widgetModel.mainChart.loading = false;
                        });
                        break;
                    case App.WidgetType.TopTenProductsByRevenue:
                        that.dashboardService.getTopProducts(facilityDetails.ClientId, facilityDetails.SiteId, cached).then(function (data) {
                            var anyValues = false;
                            widgetModel.mainChart.title = "Top Ten Products By Revenue For The Last 30 Days";
                            widgetModel.mainChart.chart.load(Enumerable.From(data.ChartData).Select(function (d) {
                                if (d.Absolute !== 0) {
                                    anyValues = true;
                                }
                                return {
                                    label: d.Label || "Other",
                                    value: d.Absolute
                                };
                            }));
                            widgetModel.mainChart.noData = !data || !data.ChartData || !anyValues;
                            widgetModel.mainChart.loading = false;
                        }, function (data) {
                            console.log("Error loading data: " + data);
                            widgetModel.mainChart.noData = true;
                            widgetModel.mainChart.loading = false;
                        });
                        break;
                    case App.WidgetType.TopTenCustomersByRevenue:
                        that.dashboardService.getTopCustomers(facilityDetails.ClientId, facilityDetails.SiteId, cached).then(function (data) {
                            var anyValues = false;
                            widgetModel.mainChart.title = "Top Ten Customers By Revenue For The Last 30 Days";
                            widgetModel.mainChart.chart.load(Enumerable.From(data.ChartData).Select(function (d) {
                                if (d.Absolute !== 0) {
                                    anyValues = true;
                                }
                                return {
                                    label: d.Label || "Other",
                                    value: d.Absolute
                                };
                            }));
                            widgetModel.mainChart.noData = !data || !data.ChartData || !anyValues;
                            widgetModel.mainChart.loading = false;
                        }, function (data) {
                            console.log("Error loading data: " + data);
                            widgetModel.mainChart.noData = true;
                            widgetModel.mainChart.loading = false;
                        });
                        break;
                    case App.WidgetType.Rolling30DaysInboundTonnagesVsSamePeriodLastYear:
                        that.dashboardService.getInboundMonthlyRollingTonnages(facilityDetails.ClientId, facilityDetails.SiteId, cached).then(function (data) {
                            var anyValues = false;
                            widgetModel.mainChart.chart.load(Enumerable.From(data.ChartData).Select(function (d) {
                                if (d.PreviousYearValue !== 0 || d.CurrentYearValue !== 0) {
                                    anyValues = true;
                                }
                                return {
                                    label: d.Label,
                                    firstValue: d.PreviousYearValue,
                                    secondValue: d.CurrentYearValue
                                };
                            }));
                            widgetModel.mainChart.noData = !data || !data.ChartData || !anyValues;
                            widgetModel.mainChart.loading = false;
                        }, function (data) {
                            console.log("Error loading data: " + data);
                            widgetModel.mainChart.noData = true;
                            widgetModel.mainChart.loading = false;
                        });
                        break;
                    case App.WidgetType.Rolling30DaysOutboundTonnagesVsSamePeriodLastYear:
                        that.dashboardService.getOutboundMonthlyRollingTonnages(facilityDetails.ClientId, facilityDetails.SiteId, cached).then(function (data) {
                            var anyValues = false;
                            widgetModel.mainChart.chart.load(Enumerable.From(data.ChartData).Select(function (d) {
                                if (d.PreviousYearValue !== 0 || d.CurrentYearValue !== 0) {
                                    anyValues = true;
                                }
                                return {
                                    label: d.Label,
                                    firstValue: d.PreviousYearValue,
                                    secondValue: d.CurrentYearValue
                                };
                            }));
                            widgetModel.mainChart.noData = !data || !data.ChartData || !anyValues;
                            widgetModel.mainChart.loading = false;
                        }, function (data) {
                            console.log("Error loading data: " + data);
                            widgetModel.mainChart.noData = true;
                            widgetModel.mainChart.loading = false;
                        });
                        break;
                    case App.WidgetType.TotalRollingRevenue:
                    case App.WidgetType.TotalRollingTonnage:
                    case App.WidgetType.NumberOfOperatorErrors:
                        var endpoint = that.replaceUrlTokens(widgeDetails.DataSourceUrl, facilityDetails);
                        that.dashboardService.getDynamicData(endpoint, cached).then(function (data) {
                            widgetModel.mainChart.chart = {
                                value: data.Value,
                                format: widgeDetails.Type === App.WidgetType.TotalRollingRevenue ? "currency" : "number"
                            };
                            widgetModel.mainChart.noData = !data || data.Value === 0;
                            widgetModel.mainChart.loading = false;
                        }, function (data) {
                            console.log("Error loading data: " + data);
                            widgetModel.mainChart.noData = true;
                            widgetModel.mainChart.loading = false;
                        });
                        break;
                }
            }
            else if (widgeDetails.DataSourceType === App.DataSourceType.DundasCsWarehouse) {
                var renderUrl = that.replaceUrlTokens(widgeDetails.DataSourceUrl, facilityDetails);
                that.dundasService.authenticate().then(function (response) {
                    widgetModel.mainChart.loading = false;
                    widgetModel.mainChart.noData = false;
                    if (response.logOnToken) {
                        renderUrl = renderUrl.replace("#{logOnToken}", response.logOnToken);
                        widgetModel.widgetExternalRenderUrl = that.sce.trustAsResourceUrl(renderUrl);
                    }
                }, function () {
                    console.log("Failed to login to dundas");
                    widgetModel.mainChart.loading = false;
                });
            }
            else if (widgeDetails.DataSourceType === App.DataSourceType.SisenseCsWarehouse) {
                that.timeoutService(function () {
                    var sisenseRenderUrl = that.replaceUrlTokens(widgeDetails.DataSourceUrl, facilityDetails) + "&cacheBuster=" + (new Date()).getTime();
                    widgetModel.widgetExternalRenderUrl = that.sce.trustAsResourceUrl(sisenseRenderUrl);
                    widgetModel.mainChart.loading = false;
                    widgetModel.mainChart.noData = false;
                }, 200);
            }
        };
        WidgetFactory.prototype.replaceUrlTokens = function (url, facilityDetails) {
            url = url.replace("#{clientId}", facilityDetails.ClientId);
            url = url.replace("#{siteId}", facilityDetails.SiteId);
            url = url.replace("#{facilityId}", facilityDetails.FacilityId.toString());
            url = url.replace("#{locationId}", facilityDetails.LocationId.toString());
            return url;
        };
        WidgetFactory.$inject = [App.Settings.Services.dashboardService, App.Settings.Services.dundasService, ngs.$sce, ngs.$timeout];
        return WidgetFactory;
    })(Service);
    App.WidgetFactory = WidgetFactory;
})(App || (App = {}));

var App;
(function (App) {
    var LaddaDirective = (function () {
        function LaddaDirective() {
            this.restrict = "A";
            this.link = function ($scope, $element, $attrs) {
                if ($element && $element[0]) {
                    var l = Ladda.create($element[0]);
                    $scope.$watch($attrs.ladda, function (newVal) {
                        if (newVal !== undefined) {
                            if (newVal)
                                l.start();
                            else
                                l.stop();
                        }
                    });
                }
            };
        }
        LaddaDirective.factory = function () {
            var directive = function () { return new LaddaDirective(); };
            return directive;
        };
        return LaddaDirective;
    })();
    App.LaddaDirective = LaddaDirective;
})(App || (App = {}));

var App;
(function (App) {
    var ObjectRequiredDirective = (function () {
        function ObjectRequiredDirective() {
            this.restrict = "A";
            this.require = "ngModel";
            this.link = function ($scope, $element, $attrs, ngModel) {
                $scope.$watch($attrs.ngModel, function (value) {
                    var isValid = !(value == null || (typeof value.Id === "undefined") || value.Id.toString() === "" || value.Id.toString() === "0");
                    ngModel.$setValidity($attrs.ngModel, isValid);
                });
            };
        }
        ObjectRequiredDirective.factory = function () {
            var directive = function () { return new ObjectRequiredDirective(); };
            return directive;
        };
        return ObjectRequiredDirective;
    })();
    App.ObjectRequiredDirective = ObjectRequiredDirective;
})(App || (App = {}));

var App;
(function (App) {
    var ngs = Common.AngularServices;
    var RcSubmitController = (function () {
        function RcSubmitController($scope) {
            var _this = this;
            this.$scope = $scope;
            var formController = null;
            this.setAttempted = function () {
                this.attempted = true;
            };
            this.setFormController = function (controller) {
                formController = controller;
            };
            this.needsAttention = function (fieldModelController) {
                if (!formController)
                    return false;
                if (fieldModelController) {
                    return fieldModelController.$invalid && (fieldModelController.$dirty || _this.attempted);
                }
                else {
                    return formController && formController.$invalid && (formController.$dirty || _this.attempted);
                }
            };
            this.filledCorrectly = function (fieldModelController) {
                if (!formController)
                    return false;
                if (fieldModelController) {
                    return fieldModelController.$valid && (fieldModelController.$dirty || _this.attempted);
                }
                else {
                    return formController && formController.$valid && (formController.$dirty || _this.attempted);
                }
            };
        }
        RcSubmitController.$inject = [ngs.$scope];
        return RcSubmitController;
    })();
    App.RcSubmitController = RcSubmitController;
    var RcSubmitDirective = (function () {
        function RcSubmitDirective($parse) {
            var _this = this;
            this.$parse = $parse;
            this.restrict = "A";
            this.require = ["rcSubmit", "?form"];
            this.controller = RcSubmitController;
            this.compile = function () {
                var that = _this;
                return {
                    pre: function (scope, formElement, attributes, controllers) {
                        var submitController = controllers[0];
                        var formController = (controllers.length > 1) ? controllers[1] : null;
                        submitController.setFormController(formController);
                        scope.rc = scope.rc || {};
                        scope.rc[attributes.name] = submitController;
                    },
                    post: function (scope, formElement, attributes, controllers) {
                        var submitController = controllers[0];
                        var formController = (controllers.length > 1) ? controllers[1] : null;
                        var fn = that.$parse(attributes.rcSubmit);
                        formElement.bind("submit", function (event) {
                            submitController.setAttempted();
                            if (!scope.$$phase)
                                scope.$apply();
                            if (!formController.$valid)
                                return false;
                            scope.$apply(function () {
                                fn(scope, { $event: event });
                            });
                            return false;
                        });
                    }
                };
            };
        }
        RcSubmitDirective.factory = function () {
            var directive = function ($parse) { return new RcSubmitDirective($parse); };
            directive.$inject = ["$parse"];
            return directive;
        };
        return RcSubmitDirective;
    })();
    App.RcSubmitDirective = RcSubmitDirective;
})(App || (App = {}));

var App;
(function (App) {
    var StatisticMultiValueTileDirective = (function () {
        function StatisticMultiValueTileDirective() {
            this.restrict = "AE";
            this.replace = true;
            this.scope = {
                colorScheme: "=",
                iconClass: "=",
                title: "=",
                leftStatTitle: "=",
                rightStatTitle: "=",
                leftStatValue: "=",
                rightStatValue: "="
            };
            this.templateUrl = "/Views/Widgets/statisticMultiValueTile.html";
            this.link = function () {
            };
        }
        StatisticMultiValueTileDirective.factory = function () {
            var directive = function () { return new StatisticMultiValueTileDirective(); };
            return directive;
        };
        return StatisticMultiValueTileDirective;
    })();
    App.StatisticMultiValueTileDirective = StatisticMultiValueTileDirective;
})(App || (App = {}));

var App;
(function (App) {
    var StatisticSingleValueTileDirective = (function () {
        function StatisticSingleValueTileDirective() {
            this.restrict = "AE";
            this.replace = true;
            this.scope = {
                colorScheme: "=",
                values: "=",
                statValue: "=",
                iconClass: "=",
                title: "=",
                statTitle: "=",
                valueClass: "="
            };
            this.templateUrl = "/Views/Widgets/statisticSingleValueTile.html";
            this.link = function () {
            };
        }
        StatisticSingleValueTileDirective.factory = function () {
            var directive = function () { return new StatisticSingleValueTileDirective(); };
            return directive;
        };
        return StatisticSingleValueTileDirective;
    })();
    App.StatisticSingleValueTileDirective = StatisticSingleValueTileDirective;
})(App || (App = {}));

var App;
(function (App) {
    var WidgetContainerDirective = (function () {
        function WidgetContainerDirective() {
            this.restrict = "EA";
            this.transclude = true;
            this.templateUrl = "Views/Widgets/widgetContainer.html";
            this.scope = {
                title: "@?",
                icon: "@?"
            };
        }
        WidgetContainerDirective.factory = function () {
            var directive = function () { return new WidgetContainerDirective(); };
            return directive;
        };
        return WidgetContainerDirective;
    })();
    App.WidgetContainerDirective = WidgetContainerDirective;
})(App || (App = {}));

"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Controller = Common.Controller;
    var ngs = Common.AngularServices;
    var Error404Controller = (function (_super) {
        __extends(Error404Controller, _super);
        function Error404Controller($scope, $location, $window, $pageTracker) {
            _super.call(this, $scope);
            this.scope.title = "Error 404: Page Not Found";
            $scope.$root.title = this.scope.title;
            this.locationService = $location;
            $pageTracker.trackPage($location.path(), this.scope.title);
        }
        Error404Controller.$inject = [ngs.$scope, ngs.$location, ngs.$window, App.Settings.Services.pageTracker];
        return Error404Controller;
    })(Controller);
    App.Error404Controller = Error404Controller;
})(App || (App = {}));

"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Controller = Common.Controller;
    var ngs = Common.AngularServices;
    var UnauthorizedController = (function (_super) {
        __extends(UnauthorizedController, _super);
        function UnauthorizedController($scope, $location, $timeout, $window, $pageTracker, $authenticationService) {
            _super.call(this, $scope);
            this.scope.title = "Unauthorized Access.";
            this.timeout = $timeout;
            this.scope.timeoutCounter = 11;
            this.authenticationService = $authenticationService;
            $scope.$root.title = this.scope.title;
            this.locationService = $location;
            var that = this;
            $pageTracker.trackPage($location.path(), this.scope.title);
            this.timeout(function () {
                that.authenticationService.logout(that.scope);
            }, 10000);
            var tick = function () {
                that.scope.timeoutCounter = that.scope.timeoutCounter === 0 ? 0 : that.scope.timeoutCounter - 1;
                that.timeout(tick, 1000); // reset the timer
            };
            this.timeout(tick, 1000);
        }
        UnauthorizedController.$inject = [ngs.$scope, ngs.$location, ngs.$timeout, ngs.$window, App.Settings.Services.pageTracker, App.Settings.Services.authenticationService];
        return UnauthorizedController;
    })(Controller);
    App.UnauthorizedController = UnauthorizedController;
})(App || (App = {}));

/// <reference path="../../../tools/typings/google.visualization/google.visualization.d.ts" />
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Controller = Common.Controller;
    var ngs = Common.AngularServices;
    var Services = App.Settings.Services;
    var DashboardController = (function (_super) {
        __extends(DashboardController, _super);
        function DashboardController($scope, $rootScope, $location, $window, $authenticationService, $dashboardService, $pageTracker, $userSettingsService, $widgetFactory, $clientSettingsService, $intervalService, $workspaceService) {
            var _this = this;
            $rootScope.clientsRetrieved = false;
            _super.call(this, $scope);
            this.top10TransactionsDataRows = [];
            var that = this;
            _super.call(this, $scope);
            $scope.$root.title = "warehouse | Dashboard";
            this.authenticationService = $authenticationService;
            this.dashboardService = $dashboardService;
            this.userSettingsService = $userSettingsService;
            this.clientSettingsService = $clientSettingsService;
            this.workspaceService = $workspaceService;
            this.rootScope = $rootScope;
            this.windowService = $window;
            this.locationService = $location;
            this.widgetFactory = $widgetFactory;
            this.intervalService = $intervalService;
            this.scope.title = "warehouse | Dashboard";
            this.scope.model = {
                facility: null,
                resetting: false,
                loading: false,
                clientsRetrieved: that.authenticationService.getClients() && that.authenticationService.getClients().length > 0,
                widgets: [],
                loadSisense: function () {
                },
                currentWorkspace: null,
                loadData: function (facility, showLoadingIndicator, cached) {
                    that.scope.model.facility = facility;
                    angular.forEach(that.scope.model.widgets, function (w) {
                        w.mainChart.loadData(facility, showLoadingIndicator, cached);
                    });
                },
                refresh: function () {
                    this.loadData(this.facility, false, false);
                },
                dashboardLayoutOptions: {
                    margins: [20, 20],
                    columns: 6,
                    draggable: {
                        enabled: false
                    },
                    resizable: {
                        enabled: false
                    }
                }
            };
            $rootScope.$on("$locationChangeStart", function (event, next, current) {
                if (next.indexOf("/dashboard") < 0) {
                    return;
                }
                that.scope.model.clientsRetrieved = true;
            });
            $rootScope.$on(App.Settings.Events.clientsRetrieved, function () {
                that.loadConfigs();
                that.scope.model.clientsRetrieved = true;
            });
            if ($rootScope.clientsRetrieved) {
                that.loadConfigs();
            }
            $rootScope.$on(App.Settings.Events.refreshRequested, function (event) {
                var that = _this;
                that.scope.model.refresh();
            });
            $rootScope.$on(App.Settings.Events.facilityChanged, function (event, facility) {
                var that = _this;
                that.scope.model.loadData(facility, true, true);
            });
            $rootScope.$on(App.Settings.Events.userRetrieved, function () {
            });
            $rootScope.$on(App.Settings.Events.workspaceLoaded, function (event, workspace, facility) {
                that.scope.model.facility = facility;
                that.loadWorkspace(workspace);
            });
            $pageTracker.trackPage($location.path(), this.scope.title);
        }
        DashboardController.prototype.connectToSisense = function () {
            var _this = this;
            if (!this.connectedToSisense) {
                if (window.Sisense) {
                    console.log("----------Connecting to sisense----------");
                    window.Sisense.connect(window.sisenseUrl).then(function (app) {
                        console.log("----------Connected to sisense----------");
                        _this.connectedToSisense = true;
                        app.dashboards.load('583797f5850ae3fc20000001').then(function (dash) {
                            console.log("----------Dashboard loaded----------");
                            $.each(dash.widgets.$$widgets, function (i, widget) {
                                widget.container = document.getElementById("widget" + (i + 1));
                            });
                            dash.refresh();
                        });
                    }, function (error) {
                        console.log("----------Failed to connect to sisense----------");
                        console.log(error);
                    });
                }
            }
        };
        DashboardController.prototype.widgetResize = function (event, $element, widget, $rootScope) {
            $rootScope.$emit("resizeMsg");
        };
        DashboardController.prototype.loadConfigs = function () {
            var that = this;
            that.rootScope.clientsRetrieved = true;
            that.clientSettingsService.getFacilityConfigurations().then(function (response) {
                angular.forEach(response.Configurations, function (clientConfig) {
                    clientConfig.FacilityConfigurations = [];
                    angular.forEach(clientConfig.SiteConfigurations, function (siteConfig) {
                        Array.prototype.push.apply(clientConfig.FacilityConfigurations, siteConfig.FacilityConfigurations);
                    });
                });
                that.rootScope.$broadcast(App.Settings.Events.facilityClientConfigurationsLoaded, response.Configurations);
            });
        };
        DashboardController.prototype.loadWorkspace = function (workspace) {
            var that = this;
            var thatModel = this.scope.model;
            thatModel.currentWorkspace = workspace;
            that.loadWidgets();
        };
        DashboardController.prototype.loadWidgets = function () {
            var that = this;
            var thatModel = that.scope.model;
            if (!thatModel.currentWorkspace || !thatModel.currentWorkspace.Widgets) {
                return;
            }
            thatModel.widgets.length = 0;
            angular.forEach(thatModel.currentWorkspace.Widgets, function (w) {
                var widgetModel = that.widgetFactory.getWidgeModel(w);
                if (widgetModel) {
                    thatModel.widgets.push(widgetModel);
                    if (thatModel.facility) {
                        widgetModel.mainChart.loadData(thatModel.facility, true, true);
                    }
                }
            });
        };
        DashboardController.$inject = [
            ngs.$scope,
            ngs.$rootScope,
            ngs.$location,
            ngs.$window,
            Services.authenticationService,
            Services.dashboardService,
            Services.pageTracker,
            Services.userSettingsService,
            Services.widgetFactory,
            Services.clientSettingsService,
            ngs.$interval,
            Services.workspaceService];
        return DashboardController;
    })(Controller);
    App.DashboardController = DashboardController;
})(App || (App = {}));

"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Controller = Common.Controller;
    var ngs = Common.AngularServices;
    var LoginController = (function (_super) {
        __extends(LoginController, _super);
        function LoginController($scope, $location, $window, $pageTracker) {
            _super.call(this, $scope);
            this.locationService = $location;
            this.scope.login = function () {
                $location.path("/");
                return false;
            };
            $pageTracker.trackPage($location.path(), this.scope.title);
        }
        LoginController.$inject = [ngs.$scope, ngs.$location, ngs.$window, App.Settings.Services.pageTracker];
        return LoginController;
    })(Controller);
    App.LoginController = LoginController;
})(App || (App = {}));

/// <reference path="../../../tools/typings/tsd.d.ts" />
/// <reference path="../../../common/controller.ts" />
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Controller = Common.Controller;
    var ngs = Common.AngularServices;
    var Services = App.Settings.Services;
    var other = Common.OtherServices;
    (function (FacilityConfigurationsMode) {
        FacilityConfigurationsMode[FacilityConfigurationsMode["AllNew"] = 1] = "AllNew";
        FacilityConfigurationsMode[FacilityConfigurationsMode["SomeNew"] = 2] = "SomeNew";
        FacilityConfigurationsMode[FacilityConfigurationsMode["AllConfigured"] = 3] = "AllConfigured";
    })(App.FacilityConfigurationsMode || (App.FacilityConfigurationsMode = {}));
    var FacilityConfigurationsMode = App.FacilityConfigurationsMode;
    var FacilityConfigurationsController = (function (_super) {
        __extends(FacilityConfigurationsController, _super);
        function FacilityConfigurationsController($scope, $rootScope, $state, $clientSettingsService, $locationService, $siteService, $toastr, $q) {
            _super.call(this, $scope);
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$clientSettingsService = $clientSettingsService;
            this.$locationService = $locationService;
            this.$siteService = $siteService;
            var that = this;
            that.clientSettingsService = $clientSettingsService;
            that.rootScope = $rootScope;
            that.locationService = $locationService;
            that.siteService = $siteService;
            that.scope.model = {
                loading: false,
                newOnly: false,
                mode: FacilityConfigurationsMode.AllNew,
                allNew: true,
                saving: false,
                isDirty: false,
                clientConfigurations: null,
                setDirty: function () {
                    that.scope.model.isDirty = true;
                },
                loadData: function () {
                    var _this = this;
                    that.scope.model.isDirty = false;
                    this.loading = true;
                    that.clientSettingsService.getFacilityConfigurations()
                        .then(function (response) {
                        _this.loading = false;
                        that.scope.model.clientConfigurations = response.Configurations;
                        angular.forEach(response.Configurations, function (config) {
                            that.siteService.getSiteLocations(config.id)
                                .then(function (response) {
                                var siteLocations = {};
                                angular.forEach(response.Locations, function (loc) {
                                    siteLocations[loc.SiteId] = siteLocations[loc.SiteId] || [];
                                    siteLocations[loc.SiteId].push(loc);
                                });
                                angular.forEach(config.SiteConfigurations, function (site) {
                                    site.Locations = siteLocations[site.Id] || [];
                                });
                            });
                        });
                    }, function (errorDetails) {
                        _this.loading = false;
                        console.log(errorDetails);
                    });
                },
                loadSiteData: function (site) {
                    var _this = this;
                    this.loading = true;
                    that.siteService.getSites(site.ClientId)
                        .then(function (response) {
                        _this.loading = false;
                        that.scope.model.sites.length = 0;
                        that.scope.model.sites = response.Sites;
                    }, function (errorDetails) {
                        _this.loading = false;
                        console.log(errorDetails);
                    });
                },
                locationChanged: function (facilityConfig, siteConfig) {
                    that.scope.model.setDirty();
                    angular.forEach(siteConfig.Locations, function (location) {
                        if (location.Id === facilityConfig.LocationId) {
                            facilityConfig.LocationName = location.Name;
                            facilityConfig.FacilityId = location.Id;
                            facilityConfig.FacilityName = location.Name;
                        }
                    });
                },
                deleteFacilityConfig: function (facilityConfig, siteConfig) {
                    that.scope.model.setDirty();
                    for (var i = 0; i < siteConfig.FacilityConfigurations.length; i++) {
                        if (siteConfig.FacilityConfigurations[i] === facilityConfig) {
                            siteConfig.FacilityConfigurations.splice(i, 1);
                            break;
                        }
                    }
                },
                addNewRow: function (site) {
                    that.scope.model.setDirty();
                    var siteRootLocation = getSiteRootLocation(site.Locations);
                    var config = {
                        Id: null,
                        ClientId: site.ClientId,
                        SiteId: site.Id,
                        SiteName: site.Name,
                        FacilityId: siteRootLocation.Id,
                        FacilityName: siteRootLocation.Name,
                        LocationId: siteRootLocation.Id,
                        LocationName: siteRootLocation.Name,
                        FacilityType: 1,
                        IsVisible: true,
                        IsNew: true,
                        SiteConfigurations: null,
                        editing: true
                    };
                    site.FacilityConfigurations.push(config);
                },
                saveData: function () {
                    var _this = this;
                    this.saving = true;
                    var facilityConfigurations = [];
                    var promises = [];
                    angular.forEach(that.scope.model.clientConfigurations, function (clientConfiguration) {
                        var clientFacilityConfigurations = [];
                        angular.forEach(clientConfiguration.SiteConfigurations, function (siteConfiguration) {
                            angular.forEach(siteConfiguration.FacilityConfigurations, function (facilityConfiguration) {
                                if (!facilityConfiguration.IsVisible)
                                    return;
                                facilityConfigurations.push(facilityConfiguration);
                                clientFacilityConfigurations.push(facilityConfiguration);
                            });
                        });
                        promises.push(that.siteService.setFacilities(clientConfiguration.id, clientFacilityConfigurations));
                    });
                    $q.all(promises).then(function (p) {
                        that.clientSettingsService.saveFacilityConfigurations(facilityConfigurations)
                            .then(function (response) {
                            _this.saving = false;
                            $rootScope.$broadcast(App.Settings.Events.facilityClientConfigurationsLoaded, that.scope.model.clientConfigurations);
                            that.scope.model.loadData();
                            $toastr.success("Facility Configurations have been updated.");
                        }, function (errorDetails) {
                            _this.saving = false;
                        });
                    }, function (p) {
                        _this.saving = false;
                        $toastr.error("There was a problem updating Facility Configurations, please try again.");
                    });
                },
                sites: [],
                setFacilityType: function (value, config) {
                    config.FacilityType = value;
                }
            };
            function getSiteRootLocation(locations) {
                var parentLocation = null;
                angular.forEach(locations, function (location) {
                    if (!location.Parent || !parentLocation || location.Parent < parentLocation.Parent) {
                        parentLocation = location;
                    }
                });
                return parentLocation || {};
            }
            that.scope.model.loadData();
            var params = $state.params;
            if (params && params.mode) {
                that.scope.model.mode = params.mode;
                if (params.mode.toString() === FacilityConfigurationsMode.AllConfigured.toString()) {
                    that.scope.model.allNew = false;
                    that.scope.model.newOnly = false;
                }
                else if (params.mode.toString() === FacilityConfigurationsMode.AllNew.toString()) {
                    that.scope.model.allNew = true;
                    that.scope.model.newOnly = false;
                }
                else if (params.mode.toString() === FacilityConfigurationsMode.SomeNew.toString()) {
                    that.scope.model.allNew = false;
                    that.scope.model.newOnly = true;
                }
            }
            else {
                that.scope.model.mode = FacilityConfigurationsMode.AllConfigured;
                that.scope.model.allNew = false;
                that.scope.model.newOnly = false;
            }
            $rootScope.$on(App.Settings.Events.clientsRetrieving, function () {
            });
            $rootScope.$on(App.Settings.Events.clientsRetrieved, function (event, clients) {
            });
            $rootScope.$on(App.Settings.Events.unauthorizedAccessDetected, function (event) {
            });
            this.rootScope.$on(App.Settings.Events.userRetrieved, function (event, user) {
            });
        }
        FacilityConfigurationsController.$inject = [ngs.$scope, ngs.$rootScope, ngs.$state, Services.clientSettingsService, ngs.$location, Services.siteService, other.toastr, ngs.$q];
        return FacilityConfigurationsController;
    })(Controller);
    App.FacilityConfigurationsController = FacilityConfigurationsController;
})(App || (App = {}));

/// <reference path="../../../tools/typings/tsd.d.ts" />
/// <reference path="../../../common/controller.ts" />
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Controller = Common.Controller;
    var ngs = Common.AngularServices;
    var SettingsController = (function (_super) {
        __extends(SettingsController, _super);
        function SettingsController($scope) {
            _super.call(this, $scope);
            this.$scope = $scope;
            this.scope.isBusy = true;
            var that = this;
        }
        SettingsController.$inject = [ngs.$scope];
        return SettingsController;
    })(Controller);
    App.SettingsController = SettingsController;
})(App || (App = {}));

/// <reference path="../../../tools/typings/tsd.d.ts" />
/// <reference path="../../../common/controller.ts" />
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Controller = Common.Controller;
    var ngs = Common.AngularServices;
    var Services = App.Settings.Services;
    var other = Common.OtherServices;
    var WidgetDetailsController = (function (_super) {
        __extends(WidgetDetailsController, _super);
        function WidgetDetailsController($scope, $rootScope, $state, $workspaceService, $dashboardService, $locationService, $toastr, selectedWidget, workspaceType, $modalInstance) {
            var _this = this;
            _super.call(this, $scope);
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$workspaceService = $workspaceService;
            this.$dashboardService = $dashboardService;
            this.$locationService = $locationService;
            this.selectedWidget = selectedWidget;
            this.workspaceType = workspaceType;
            var that = this;
            that.workspaceService = $workspaceService;
            that.dashboardService = $dashboardService;
            that.rootScope = $rootScope;
            that.modalInstance = $modalInstance;
            that.locationService = $locationService;
            that.scope.model = {
                widget: this.selectedWidget,
                loading: false,
                saving: false,
                confirmed: false,
                errorText: "",
                saveData: function (hasChanges) {
                    if (!hasChanges) {
                        that.modalInstance.close();
                        return;
                    }
                    that.workspaceService.saveWidgetDetails(that.buildWidgetDetails(), workspaceType)
                        .then(function (response) {
                        that.modalInstance.close(that.buildWidgetDetails());
                    }, function (error) {
                        that.scope.model
                            .errorText =
                            "Failed to save widget details. Please try again later. Reason: " + error;
                    });
                },
                loadData: function () {
                },
                delete: function () {
                    that.workspaceService.unPublishWidget(that.scope.model.widget.Id, workspaceType)
                        .then(function (response) {
                        that.modalInstance.close(that.buildWidgetDetails());
                    }, function (error) {
                        that.scope.model
                            .errorText =
                            "Failed to delete widget. Please try again later. Reason: " + error;
                    });
                },
                publish: function () {
                },
                cancel: function () {
                    _this.modalInstance.dismiss("cancel");
                },
                title: this.selectedWidget.Title,
                x: this.selectedWidget.X,
                y: this.selectedWidget.Y,
                width: this.selectedWidget.Width,
                height: this.selectedWidget.Height,
                url: this.selectedWidget.DataSourceUrl,
                id: this.selectedWidget.ExternalId,
                isSisense: this.selectedWidget.DataSourceType === App.DataSourceType.SisenseCsWarehouse,
                type: this.selectedWidget.Type,
                style: this.selectedWidget.Style,
                types: [
                    new App.TypeLookup(App.WidgetType.Rolling30DaysInboundTonnagesVsSamePeriodLastYear, App.WidgetType[App.WidgetType.Rolling30DaysInboundTonnagesVsSamePeriodLastYear]),
                    new App.TypeLookup(App.WidgetType.Rolling30DaysOutboundTonnagesVsSamePeriodLastYear, App.WidgetType[App.WidgetType.Rolling30DaysOutboundTonnagesVsSamePeriodLastYear]),
                    new App.TypeLookup(App.WidgetType.Rolling30DaysRevenueVsSamePeriodLastYear, App.WidgetType[App.WidgetType.Rolling30DaysRevenueVsSamePeriodLastYear]),
                    new App.TypeLookup(App.WidgetType.Rolling30DaysTonnagesVsRevenue, App.WidgetType[App.WidgetType.Rolling30DaysTonnagesVsRevenue]),
                    new App.TypeLookup(App.WidgetType.Rolling30DaysTonnagesVsSamePeriodLastYear, App.WidgetType[App.WidgetType.Rolling30DaysTonnagesVsSamePeriodLastYear]),
                    new App.TypeLookup(App.WidgetType.Rolling6MonthsAvgHoulyTransactionCount, App.WidgetType[App.WidgetType.Rolling6MonthsAvgHoulyTransactionCount]),
                    new App.TypeLookup(App.WidgetType.Rolling30DaysTransactionCountsVsSamePeriodLastYear, App.WidgetType[App.WidgetType.Rolling30DaysTransactionCountsVsSamePeriodLastYear]),
                    new App.TypeLookup(App.WidgetType.AverageTransactionProcessingTime, App.WidgetType[App.WidgetType.AverageTransactionProcessingTime]),
                    new App.TypeLookup(App.WidgetType.NumberOfOperatorErrors, App.WidgetType[App.WidgetType.NumberOfOperatorErrors]),
                    new App.TypeLookup(App.WidgetType.Rolling7DaysCancelledAndAmendedTransactions, App.WidgetType[App.WidgetType.Rolling7DaysCancelledAndAmendedTransactions]),
                    new App.TypeLookup(App.WidgetType.Rolling6MonthsAvgWeekdayTransactionCount, App.WidgetType[App.WidgetType.Rolling6MonthsAvgWeekdayTransactionCount]),
                    new App.TypeLookup(App.WidgetType.TopTenCustomersByRevenue, App.WidgetType[App.WidgetType.TopTenCustomersByRevenue]),
                    new App.TypeLookup(App.WidgetType.TopTenProductsByRevenue, App.WidgetType[App.WidgetType.TopTenProductsByRevenue]),
                    new App.TypeLookup(App.WidgetType.TotalRollingRevenue, App.WidgetType[App.WidgetType.TotalRollingRevenue]),
                    new App.TypeLookup(App.WidgetType.TotalRollingTonnage, App.WidgetType[App.WidgetType.TotalRollingTonnage]),
                    new App.TypeLookup(App.WidgetType.Rolling6MonthsWeeklyTransactionCount, App.WidgetType[App.WidgetType.Rolling6MonthsWeeklyTransactionCount])
                ],
                styles: [
                    new App.StyleLookup(App.WidgetStyle.BarChart, App.WidgetStyle[App.WidgetStyle.BarChart]),
                    new App.StyleLookup(App.WidgetStyle.AreaChart, App.WidgetStyle[App.WidgetStyle.AreaChart]),
                    new App.StyleLookup(App.WidgetStyle.ColumnChart, App.WidgetStyle[App.WidgetStyle.ColumnChart]),
                    new App.StyleLookup(App.WidgetStyle.LineChart, App.WidgetStyle[App.WidgetStyle.LineChart]),
                    new App.StyleLookup(App.WidgetStyle.Number, App.WidgetStyle[App.WidgetStyle.Number]),
                    new App.StyleLookup(App.WidgetStyle.PieChart, App.WidgetStyle[App.WidgetStyle.PieChart]),
                    new App.StyleLookup(App.WidgetStyle.StackedChart, App.WidgetStyle[App.WidgetStyle.StackedChart]),
                    new App.StyleLookup(App.WidgetStyle.Table, App.WidgetStyle[App.WidgetStyle.Table])
                ]
            };
            that.scope.model.loadData();
            var jq = $;
            if (jq.material) {
                jq.material.init();
            }
            $rootScope.$on(App.Settings.Events.clientsRetrieving, function () {
            });
            $rootScope.$on(App.Settings.Events.clientsRetrieved, function (event, clients) {
            });
            $rootScope.$on(App.Settings.Events.unauthorizedAccessDetected, function (event) {
            });
            this.rootScope.$on(App.Settings.Events.userRetrieved, function (event, user) {
            });
        }
        WidgetDetailsController.prototype.buildWidgetDetails = function () {
            var model = this.scope.model;
            return {
                Id: model.widget.Id,
                X: model.x,
                Y: model.y,
                Width: model.width,
                Height: model.height,
                Title: model.title,
                ExternalId: model.id,
                DataSourceUrl: model.url,
                DataSourceType: model.isSisense ? App.DataSourceType.SisenseCsWarehouse : App.DataSourceType.MandalayCsWarehouse,
                Style: model.style,
                Type: model.type
            };
        };
        WidgetDetailsController.$inject = [ngs.$scope, ngs.$rootScope, ngs.$state, Services.workspaceService, Services.dashboardService, ngs.$location, other.toastr, "selectedWidget", "workspaceType", ngs.$modalInstance];
        return WidgetDetailsController;
    })(Controller);
    App.WidgetDetailsController = WidgetDetailsController;
})(App || (App = {}));

/// <reference path="../../../tools/typings/tsd.d.ts" />
/// <reference path="../../../common/controller.ts" />
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Controller = Common.Controller;
    var ngs = Common.AngularServices;
    var Services = App.Settings.Services;
    var other = Common.OtherServices;
    var WidgetPublishDetailsController = (function (_super) {
        __extends(WidgetPublishDetailsController, _super);
        function WidgetPublishDetailsController($scope, $rootScope, $state, $workspaceService, $dashboardService, $locationService, $toastr, selectedWidget, selectedDashboard, workspaceType, x, y, $modalInstance) {
            var _this = this;
            _super.call(this, $scope);
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$workspaceService = $workspaceService;
            this.$dashboardService = $dashboardService;
            this.$locationService = $locationService;
            this.selectedWidget = selectedWidget;
            this.selectedDashboard = selectedDashboard;
            this.workspaceType = workspaceType;
            this.x = x;
            this.y = y;
            var that = this;
            console.log(selectedWidget);
            console.log(this.selectedWidget);
            that.workspaceService = $workspaceService;
            that.dashboardService = $dashboardService;
            that.rootScope = $rootScope;
            that.modalInstance = $modalInstance;
            that.locationService = $locationService;
            that.scope.model = {
                widget: this.selectedWidget,
                loading: false,
                saving: false,
                confirmed: false,
                errorText: "",
                publish: function (hasChanges) {
                    if (that.scope.model.height < 0 || that.scope.model.height > 10) {
                        that.scope.model.errorText = "Height must be between 1 and 10";
                        return;
                    }
                    if (that.scope.model.x < 1 || that.scope.model.x > 30) {
                        that.scope.model.errorText = "X must be between 1 and 30";
                        return;
                    }
                    if (that.scope.model.y > 5 || that.scope.model.y < 1) {
                        that.scope.model.errorText = "Y must be between 1 and 5";
                        return;
                    }
                    if (that.scope.model.width > 6 || that.scope.model.width < 1) {
                        that.scope.model.errorText = "Width must be between 1 and 5";
                        return;
                    }
                    that.workspaceService.publishSisenseWidget(that.buildWidgetDetails(), workspaceType)
                        .then(function (response) {
                        that.modalInstance.close(that.buildWidgetDetails());
                    }, function (error) {
                        var text = error;
                        if (error && error.Message) {
                            text = error.Message;
                        }
                        that.scope.model
                            .errorText =
                            "Failed to save widget details. Please try again later. Reason: " + text;
                    });
                },
                cancel: function () {
                    _this.modalInstance.dismiss("cancel");
                },
                title: this.selectedWidget.title,
                x: that.x,
                y: that.y,
                width: 2,
                height: 1,
                url: "https://sisense-dev.naus.com/app/main#/dashboards/" + this.selectedDashboard.oid + "/widgets/" + this.selectedWidget.oid + "?embed=true&facilityId=#{facilityId}&clientId=#{clientId}",
                id: this.selectedWidget.oid
            };
            var jq = $;
            if (jq.material) {
                jq.material.init();
            }
            $rootScope.$on(App.Settings.Events.clientsRetrieving, function () {
            });
            $rootScope.$on(App.Settings.Events.clientsRetrieved, function (event, clients) {
            });
            $rootScope.$on(App.Settings.Events.unauthorizedAccessDetected, function (event) {
            });
            this.rootScope.$on(App.Settings.Events.userRetrieved, function (event, user) {
            });
        }
        WidgetPublishDetailsController.prototype.buildWidgetDetails = function () {
            var model = this.scope.model;
            return {
                Id: model.widget.Id,
                X: model.x,
                Y: model.y,
                Width: model.width,
                Height: model.height,
                Title: model.title,
                ExternalId: model.id,
                DataSourceUrl: model.url,
                DataSourceType: App.DataSourceType.SisenseCsWarehouse,
                Style: App.WidgetStyle.Custom,
                Type: App.WidgetType.Generic
            };
        };
        WidgetPublishDetailsController.$inject = [ngs.$scope, ngs.$rootScope, ngs.$state, Services.workspaceService, Services.dashboardService, ngs.$location, other.toastr, "selectedWidget", "selectedDashboard", "workspaceType", "x", "y", ngs.$modalInstance];
        return WidgetPublishDetailsController;
    })(Controller);
    App.WidgetPublishDetailsController = WidgetPublishDetailsController;
})(App || (App = {}));

/// <reference path="../../../tools/typings/tsd.d.ts" />
/// <reference path="../../../common/controller.ts" />
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Controller = Common.Controller;
    var ngs = Common.AngularServices;
    var Services = App.Settings.Services;
    var other = Common.OtherServices;
    var WorkspaceTypeWidgetsController = (function (_super) {
        __extends(WorkspaceTypeWidgetsController, _super);
        function WorkspaceTypeWidgetsController($scope, $rootScope, $state, $workspaceService, $dashboardService, $locationService, $toastr, $modal) {
            _super.call(this, $scope);
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$workspaceService = $workspaceService;
            this.$dashboardService = $dashboardService;
            this.$locationService = $locationService;
            this.x = 0;
            this.y = 0;
            var that = this;
            that.workspaceService = $workspaceService;
            that.dashboardService = $dashboardService;
            that.rootScope = $rootScope;
            that.modal = $modal;
            that.locationService = $locationService;
            that.scope.model = {
                loadingUsed: false,
                loadingAvailable: false,
                workspaceType: App.WorkspaceType.Landfill,
                widgets: [],
                availableSisenseWidgets: [],
                saving: false,
                availableCount: function () {
                    var count = 0;
                    for (var k = 0; k < that.scope.model.availableSisenseWidgets.length; k++) {
                        count += that.scope.model.availableSisenseWidgets[k].widgets.length;
                    }
                    return count;
                },
                loadData: function () {
                    var _this = this;
                    this.loadingUsed = true;
                    that.workspaceService.geWorkspaceTypeWidgets(that.scope.model.workspaceType).then(function (response) {
                        _this.loadingUsed = false;
                        _this.widgets = response.Widgets;
                        var next = that.getNextAvailableSlot(_this.widgets);
                        that.x = next.x;
                        that.y = next.y;
                    }, function (errorDetails) {
                        _this.loadingUsed = false;
                        console.log(errorDetails);
                    });
                    this.loadingAvailable = true;
                    that.workspaceService.geAvailableSisenseWidgets(that.scope.model.workspaceType).then(function (response) {
                        _this.loadingAvailable = false;
                        _this.availableSisenseWidgets = response.dashboards;
                    }, function (errorDetails) {
                        _this.loadingAvailable = false;
                        console.log(errorDetails);
                    });
                },
                saveData: function () {
                },
                reload: function () {
                    that.scope.model.loadData();
                },
                edit: function (widget) {
                    var modalInstance = that.modal.open({
                        templateUrl: "/wwwroot/views/settings/widgetDetails.html",
                        controller: App.Settings.Controllers.widgetDetailsController,
                        resolve: {
                            selectedWidget: function () {
                                return widget;
                            },
                            workspaceType: function () {
                                return that.scope.model.workspaceType;
                            }
                        }
                    });
                    modalInstance.result.then(function (widget) {
                        if (widget) {
                            $toastr.success("Successfully saved details of widget '" + widget.Title + "'");
                            that.scope.model.reload();
                        }
                    }, function (error) {
                        console.log(error);
                    });
                },
                delete: function (widget) {
                    var modalInstance = that.modal.open({
                        templateUrl: "/wwwroot/views/settings/widgetDeleteConfirm.html",
                        controller: App.Settings.Controllers.widgetDetailsController,
                        resolve: {
                            selectedWidget: function () {
                                return widget;
                            },
                            workspaceType: function () {
                                return that.scope.model.workspaceType;
                            }
                        }
                    });
                    modalInstance.result.then(function (widget) {
                        $toastr.success("Successfully deleted '" + widget.Title + "'", "Success");
                        that.scope.model.reload();
                    }, function () {
                        console.log("Canceled dialog");
                    });
                },
                publish: function (widget, dashboard) {
                    var modalInstance = that.modal.open({
                        templateUrl: "/wwwroot/views/settings/widgetPublish.html",
                        controller: App.Settings.Controllers.widgetPublishDetailsController,
                        resolve: {
                            selectedWidget: function () {
                                return widget;
                            },
                            selectedDashboard: function () {
                                return dashboard;
                            },
                            x: function () {
                                return that.x;
                            },
                            y: function () {
                                return that.y;
                            },
                            workspaceType: function () {
                                return that.scope.model.workspaceType;
                            }
                        }
                    });
                    modalInstance.result.then(function (widget) {
                        if (widget) {
                            $toastr.success("Successfully published widget '" + widget.Title + "'");
                            that.scope.model.reload();
                        }
                    }, function (error) {
                        console.log(error);
                    });
                }
            };
            var params = $state.params;
            if (params && params.workspaceType) {
                that.scope.model.workspaceType = params.workspaceType;
                that.scope.model.loadData();
            }
            else {
                $toastr.error("Specified workspace type is invalid.");
                that.locationService.path('/workspace-types');
            }
            var jq = $;
            if (jq.material) {
                jq.material.init();
            }
            $rootScope.$on(App.Settings.Events.clientsRetrieving, function () {
            });
            $rootScope.$on(App.Settings.Events.clientsRetrieved, function (event, clients) {
            });
            $rootScope.$on(App.Settings.Events.unauthorizedAccessDetected, function (event) {
            });
            this.rootScope.$on(App.Settings.Events.userRetrieved, function (event, user) {
            });
        }
        WorkspaceTypeWidgetsController.prototype.getNextAvailableSlot = function (widgets) {
            var lastRowWidgets = [];
            var currentMaxX = 0;
            for (var i = 0; i < widgets.length; i++) {
                if (currentMaxX > widgets[i].X) {
                    continue;
                }
                if (currentMaxX < widgets[i].X) {
                    lastRowWidgets.length = 0;
                    currentMaxX = widgets[i].X;
                }
                lastRowWidgets.push(widgets[i]);
            }
            if (lastRowWidgets.length === 0)
                return { x: 0, y: 0 };
            var rowOffsetRequired = false;
            var rowOffset = 0;
            var columnOffset = 0;
            for (var j = 0; j < lastRowWidgets.length; j++) {
                var wid = lastRowWidgets[j];
                if (columnOffset < wid.Width + wid.Y) {
                    columnOffset = wid.Width + wid.Y;
                }
                if (rowOffset < wid.Height + 1) {
                    rowOffset = wid.Height + 1;
                }
                if (wid.Y >= 4) {
                    rowOffsetRequired = true;
                }
            }
            if (rowOffsetRequired) {
                return { x: rowOffset, y: 0 };
            }
            return { x: lastRowWidgets[0].X, y: columnOffset };
        };
        WorkspaceTypeWidgetsController.$inject = [ngs.$scope, ngs.$rootScope, ngs.$state, Services.workspaceService, Services.dashboardService, ngs.$location, other.toastr, ngs.$modal];
        return WorkspaceTypeWidgetsController;
    })(Controller);
    App.WorkspaceTypeWidgetsController = WorkspaceTypeWidgetsController;
})(App || (App = {}));

/// <reference path="../../../tools/typings/tsd.d.ts" />
/// <reference path="../../../common/controller.ts" />
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Controller = Common.Controller;
    var ngs = Common.AngularServices;
    var Services = App.Settings.Services;
    var other = Common.OtherServices;
    var WorkspaceTypesController = (function (_super) {
        __extends(WorkspaceTypesController, _super);
        function WorkspaceTypesController($scope, $rootScope, $state, $workspaceService, $dashboardService, $locationService, $toastr) {
            _super.call(this, $scope);
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$workspaceService = $workspaceService;
            this.$dashboardService = $dashboardService;
            this.$locationService = $locationService;
            var that = this;
            that.workspaceService = $workspaceService;
            that.dashboardService = $dashboardService;
            that.rootScope = $rootScope;
            that.locationService = $locationService;
            that.scope.model = {
                workspaceTypes: [],
                loading: false,
                setSelectedWorkspaceType: function (workspaceType) {
                    that.scope.model.selectedWorkspaceType = workspaceType;
                    that.locationService.path("/workspace-type-widgets/" + workspaceType);
                },
                selectedWorkspaceType: App.WorkspaceType.Landfill,
                loadData: function () {
                    var _this = this;
                    that.scope.model.loading = true;
                    that.workspaceService.geWorkspaceTypes().then(function (response) {
                        _this.loading = false;
                        _this.workspaceTypes.length = 0;
                        _this.workspaceTypes = response.WorkspaceTypes;
                    }, function (errorDetails) {
                        _this.loading = false;
                        console.log(errorDetails);
                    });
                }
            };
            that.scope.model.loadData();
            $rootScope.$on(App.Settings.Events.clientsRetrieving, function () {
            });
            $rootScope.$on(App.Settings.Events.clientsRetrieved, function (event, clients) {
            });
            $rootScope.$on(App.Settings.Events.unauthorizedAccessDetected, function (event) {
            });
            this.rootScope.$on(App.Settings.Events.userRetrieved, function (event, user) {
            });
        }
        WorkspaceTypesController.$inject = [ngs.$scope, ngs.$rootScope, ngs.$state, Services.workspaceService, Services.dashboardService, ngs.$location, other.toastr];
        return WorkspaceTypesController;
    })(Controller);
    App.WorkspaceTypesController = WorkspaceTypesController;
})(App || (App = {}));

/// <reference path="../../../tools/typings/tsd.d.ts" />
/// <reference path="../../../common/controller.ts" />
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Controller = Common.Controller;
    var ngs = Common.AngularServices;
    var Services = App.Settings.Services;
    var MainController = (function (_super) {
        __extends(MainController, _super);
        function MainController($scope, $rootScope, $authenticationService, $accountService) {
            _super.call(this, $scope);
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$authenticationService = $authenticationService;
            this.$accountService = $accountService;
            this.authenticationService = $authenticationService;
            this.rootScope = $rootScope;
            this.scope.isBusy = true;
            this.scope.logged = !!this.authenticationService.getCurrentUser();
            var that = this;
            $rootScope.$on(App.Settings.Events.clientsRetrieving, function () {
                that.scope.isBusy = true;
                that.scope.busyText = "Checking available client data";
            });
            $rootScope.$on(App.Settings.Events.clientsRetrieved, function (event, clients) {
                that.scope.isBusy = false;
            });
            $rootScope.$on(App.Settings.Events.unauthorizedAccessDetected, function (event) {
                that.scope.isBusy = false;
            });
            this.rootScope.$on(App.Settings.Events.userRetrieved, function (event, user) {
                that.scope.logged = !!user;
            });
        }
        MainController.$inject = [ngs.$scope, ngs.$rootScope, Services.authenticationService];
        return MainController;
    })(Controller);
    App.MainController = MainController;
})(App || (App = {}));

/// <reference path="../../../tools/typings/tsd.d.ts" />
/// <reference path="../../../common/controller.ts" />
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var App;
(function (App) {
    var Controller = Common.Controller;
    var ngs = Common.AngularServices;
    var Services = App.Settings.Services;
    var MenuController = (function (_super) {
        __extends(MenuController, _super);
        function MenuController($scope, $rootScope, $authenticationService, $accountService, $userSettingsService, $locationService, $siteService) {
            var _this = this;
            _super.call(this, $scope);
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$authenticationService = $authenticationService;
            this.$accountService = $accountService;
            this.$userSettingsService = $userSettingsService;
            this.$locationService = $locationService;
            this.$siteService = $siteService;
            this.authenticationService = $authenticationService;
            this.userSettingsService = $userSettingsService;
            this.rootScope = $rootScope;
            this.accountService = $accountService;
            this.siteService = $siteService;
            this.scope.user = this.authenticationService.getCurrentUser();
            this.scope.title = "Menu Widget";
            this.scope.logged = !!this.authenticationService.getCurrentUser();
            this.scope.profileUrl = window.profileUrl;
            var that = this;
            this.scope.model = {
                isLinkSelected: function (link, counter) {
                    return (link === this.currentLink || window.location.pathname.indexOf(link) >= 0)
                        && counter > 0
                        ? "selected"
                        : "unselected";
                },
                currentLink: "dashboard",
                isAdmin: false,
                currentWorkspace: null,
                linkAvailable: !!(this.scope.user),
                setCurrentLink: function (link, counter) {
                    if (counter > 0) {
                        this.currentLink = link;
                    }
                },
                showFilter: $locationService.path().indexOf("dashboard") >= 0,
                logout: function () {
                    that.authenticationService.logout($scope);
                },
                clients: [],
                clientConfigs: [],
                workspaces: [],
                selectedFacility: null,
                imageUrl: that.scope.user && that.scope.user.ImageUrl ? that.scope.user.ImageUrl : "./wwwroot/images/avatar.jpg",
                cacheBuster: that.scope.user && that.scope.user.ImageUrl && that.scope.user.ImageUrl.indexOf("gravatar") < 0 ? "?" + new Date().getTime() : "",
                alerts: 0,
                showModelLinks: that.scope.user && that.scope.user.NausDetails,
                showAdminOptions: false,
                requestRefresh: function () {
                    that.rootScope.$broadcast(App.Settings.Events.refreshRequested);
                },
                selectFacility: function (facility) {
                    that.scope.model.selectedFacility = facility;
                    if (that.scope.model.currentWorkspace.Id === facility.Id) {
                        that.rootScope.$broadcast(App.Settings.Events.facilityChanged, facility);
                    }
                    else {
                        angular.forEach(that.scope.model.workspaces, function (item) {
                            if (item.Id === facility.Id) {
                                that.setWorkspaceFacility(item);
                                that.userSettingsService.saveLastViewedWorkspace(facility.Id).then(function () {
                                    console.log("Saved last viewed workspace");
                                });
                                return;
                            }
                        });
                    }
                }
            };
            that.userSettingsService.canPublish()
                .then(function (data) {
                if (data.CanPublish) {
                    that.scope.model.isAdmin = data.CanPublish;
                }
                else {
                    that.scope.model.isAdmin = false;
                }
            });
            $rootScope.$on("$locationChangeStart", function (event, next, current) {
                that.scope.model.showFilter = next.indexOf("/dashboard") >= 0;
            });
            $rootScope.$on(App.Settings.Events.clientsRetrieved, function (event, clients) {
                that.scope.logged = !!_this.scope.user;
                that.scope.model.clients = clients;
            });
            $rootScope.$on(App.Settings.Events.facilityClientConfigurationsLoaded, function (event, clientConfigs) {
                that.scope.model.clientConfigs = clientConfigs;
                that.userSettingsService.getUserWorkspaces().then(function (response) {
                    if (response.Workspaces.length > 0) {
                        that.rootScope.$broadcast(App.Settings.Events.workspacesLoaded, response.Workspaces);
                        that.scope.model.workspaces.length = 0;
                        that.scope.model.workspaces = response.Workspaces;
                        that.userSettingsService.getLastViewedWorkspace().then(function (lastViewedResponse) {
                            that.scope.model.currentWorkspace = null;
                            that.scope.model.selectedFacility = null;
                            if (lastViewedResponse &&
                                lastViewedResponse.WorkspaceDetails &&
                                lastViewedResponse.WorkspaceDetails.Id) {
                                var foundWorkspace;
                                angular.forEach(response.Workspaces, function (ws) {
                                    if (ws.Id === lastViewedResponse.WorkspaceDetails.Id) {
                                        that.setWorkspaceFacility(lastViewedResponse.WorkspaceDetails);
                                        foundWorkspace = true;
                                    }
                                });
                                if (!foundWorkspace)
                                    that.setWorkspaceFacility(response.Workspaces[0]);
                            }
                            else {
                                that.setWorkspaceFacility(response.Workspaces[0]);
                            }
                        }, function () {
                            that.setWorkspaceFacility(response.Workspaces[0]);
                        });
                    }
                    else {
                        that.scope.model.currentWorkspace = null;
                        that.scope.model.selectedFacility = null;
                    }
                }, function () {
                    console.log("Error getting workspace");
                });
            });
            this.rootScope.$on(App.Settings.Events.userRetrieved, function (event, user) {
                if (!!that.authenticationService.getClients()) {
                    that.scope.logged = that.authenticationService.getClients().length > 0;
                }
                that.userSettingsService.canPublish()
                    .then(function (data) {
                    if (data.CanPublish) {
                        that.scope.model.isAdmin = data.CanPublish;
                    }
                    else {
                        that.scope.model.isAdmin = false;
                    }
                });
                $scope.model.linkAvailable = true;
                _this.scope.user = user;
                if (user.ImageUrl) {
                    $scope.model.imageUrl = user.ImageUrl;
                    $scope.model.cacheBuster = user.ImageUrl.indexOf("gravatar") >= 0 ? "" : "?" + new Date().getTime();
                }
                $scope.model.showModelLinks = user && user.NausDetails;
            });
            this.scope.$on("notifications", function (event, data) {
                $scope.$apply(function () {
                    $scope.model.alerts += data.length;
                    $scope.model.alerts = $scope.model.alerts % 20;
                });
            });
        }
        MenuController.prototype.getTitle = function () {
            return this.scope.title;
        };
        MenuController.prototype.setWorkspaceFacility = function (workspace) {
            var that = this;
            that.scope.model.currentWorkspace = workspace;
            if (!that.scope.model.currentWorkspace || !that.scope.model.currentWorkspace.FacilityId) {
                if (that.scope.model.clientConfigs.length &&
                    that.scope.model.clientConfigs[0].FacilityConfigurations.length) {
                    that.scope.model.selectedFacility = that.scope.model.clientConfigs[0].FacilityConfigurations[0];
                    that.rootScope.$broadcast(App.Settings.Events.facilityChanged, that.scope.model.selectedFacility);
                }
            }
            else {
                angular.forEach(that.scope.model.clientConfigs, function (clientConfig) {
                    var matchingFacility = Enumerable
                        .From(clientConfig.FacilityConfigurations)
                        .FirstOrDefault(null, function (c) {
                        return c.Id === that.scope.model.currentWorkspace.Id;
                    });
                    if (matchingFacility) {
                        that.scope.model.selectedFacility = matchingFacility;
                        that.rootScope.$broadcast(App.Settings.Events.facilityChanged, matchingFacility);
                        return;
                    }
                });
            }
            that.rootScope.$broadcast(App.Settings.Events.workspaceLoaded, that.scope.model.currentWorkspace, that.scope.model.selectedFacility);
        };
        MenuController.prototype.setFacilityType = function (value, clientConfig) {
            clientConfig.FacilityType = value;
        };
        MenuController.$inject = [ngs.$scope, ngs.$rootScope, Services.authenticationService, Services.accountService, Services.userSettingsService, ngs.$location, Services.siteService];
        return MenuController;
    })(Controller);
    App.MenuController = MenuController;
})(App || (App = {}));

"use strict";
// Register all directives
var filtersModule = new Common.Module("app.filters", []);
filtersModule.addFilter(App.Settings.Filters.offset, App.OffsetFilter);
filtersModule.addFilter(App.Settings.Filters.secondsToTime, App.SecondsToTimeFilter);
// Register all directives
var directivesModule = new Common.Module("app.directives", []);
directivesModule.addDirective(App.Settings.Directives.objectRequired, App.ObjectRequiredDirective.factory());
directivesModule.addDirective(App.Settings.Directives.ladda, App.LaddaDirective.factory());
directivesModule.addDirective(App.Settings.Directives.statisticMultiValueTile, App.StatisticMultiValueTileDirective.factory());
directivesModule.addDirective(App.Settings.Directives.statisticSingleValueTile, App.StatisticSingleValueTileDirective.factory());
directivesModule.addDirective(App.Settings.Directives.rcSubmit, App.RcSubmitDirective.factory());
directivesModule.addDirective(App.Settings.Directives.widgetContainer, App.WidgetContainerDirective.factory());
// Register all services
var servicesModule = new Common.Module("app.services", []);
servicesModule.addService(App.Settings.Services.httpHandlerService, App.HttpHandlerService);
servicesModule.addService(App.Settings.Services.accountService, App.AccountService);
servicesModule.addService(App.Settings.Services.dashboardService, App.DashboardService);
servicesModule.addService(App.Settings.Services.locationService, App.LocationService);
servicesModule.addService(App.Settings.Services.notificationService, App.NotificationService);
servicesModule.addService(App.Settings.Services.resourceService, App.ResourceService);
servicesModule.addService(App.Settings.Services.authenticationService, App.AuthenticationService);
servicesModule.addService(App.Settings.Services.pingService, App.PingService);
servicesModule.addService(App.Settings.Services.pageTracker, App.PageTracker);
servicesModule.addService(App.Settings.Services.userSettingsService, App.UserSettingsService);
servicesModule.addService(App.Settings.Services.widgetFactory, App.WidgetFactory);
servicesModule.addService(App.Settings.Services.clientSettingsService, App.ClientSettingsService);
servicesModule.addService(App.Settings.Services.dundasService, App.DundasService);
servicesModule.addService(App.Settings.Services.workspaceService, App.WorkspaceService);
servicesModule.addService(App.Settings.Services.siteService, App.SiteService);
// Register all controllers
var controllersModule = new Common.Module("app.controllers", ["app.services"]);
controllersModule.addController(App.Settings.Controllers.mainController, App.MainController);
controllersModule.addController(App.Settings.Controllers.menuController, App.MenuController);
controllersModule.addController(App.Settings.Controllers.dashboardController, App.DashboardController);
controllersModule.addController(App.Settings.Controllers.unauthorizedController, App.UnauthorizedController);
controllersModule.addController(App.Settings.Controllers.error404Controller, App.Error404Controller);
controllersModule.addController(App.Settings.Controllers.loginController, App.LoginController);
controllersModule.addController(App.Settings.Controllers.settingsController, App.SettingsController);
controllersModule.addController(App.Settings.Controllers.facilityConfigurationsController, App.FacilityConfigurationsController);
controllersModule.addController(App.Settings.Controllers.workspaceTypesController, App.WorkspaceTypesController);
controllersModule.addController(App.Settings.Controllers.workspaceTypeWidgetsController, App.WorkspaceTypeWidgetsController);
controllersModule.addController(App.Settings.Controllers.widgetPublishDetailsController, App.WidgetPublishDetailsController);
controllersModule.addController(App.Settings.Controllers.widgetDetailsController, App.WidgetDetailsController);
// Create main application module with all required dependencies
var mainModule = new Common.Module("app", ["ngAnimate", "ngBootbox", "chieffancypants.loadingBar", "toastr", "ngSanitize", "oauth", "ngStorage", "ui.router", "app.filters", "app.services", "app.directives", "app.controllers", "ui.bootstrap", "flow", "googlechart", "gridster", "rt.debounce"]);
// Add ui navigation configurations
mainModule.addConfig(App.AppRoutes);
// Add error handling
mainModule.addConfig(App.ExceptionHandlerConfig);
// Entry point for the app
mainModule.app.run(App.MainRunner);

/// <reference path="../tools/typings/tsd.d.ts" />
// fix for menu toogle on mobile devices as per https://github.com/twbs/bootstrap/issues/9013
$(function () {
    $(document).on("click", ".navbar-collapse.in", function (e) {
        if ($(e.target).is("a")) {
            $(this).collapse("hide");
        }
    });
});

/// <reference path="../tools/typings/tsd.d.ts" />
// fix for menu toogle on mobile devices as per https://github.com/twbs/bootstrap/issues/9013
$(function () {
    $.reject({
        reject: {
            safari: false,
            chrome: false,
            firefox: false,
            msie: 9,
            opera: true,
            konqueror: true,
            unknown: true // Everything else
        },
        beforeReject: function () {
            if ($.os.name === "iphone" || $.os.name === "ipad") {
                this.browserShow = false;
                this.paragraph2 = "";
            }
            else {
                this.display = ["safari", "chrome", "msie", "firefox"];
            }
        },
        close: false,
        header: "naus is not supported on your current browser",
        paragraph1: "A list of supported browsers is available <a href=\"https://mandalay.atlassian.net/wiki/display/nausConsulting/naus+Support+Offering#nausSupportOffering-SupportedBrowsers\">here</a>.",
        paragraph2: "Please install one of the following browsers to access naus."
    }); // Customized Browsers
});
